<!-- rota: /fatura/copergelenfatura/:id  (name: fatura-copergelenfatura) -->
<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <onaydialog ref="onaydialog"></onaydialog>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
   
    <v-form ref="formgelenfatura" v-model="validform" lazy-validation>
      <v-card flat color="grey lighten-5">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{sayfabaslik}} <span v-if="islemtipi!=1"> -  {{  getSaticiTip(GelenFatura.Fatura.SaticiTip)  }}</span> </v-toolbar-title>
              <v-spacer></v-spacer>

<!-- PDY Yükle (beta) -->
<v-tooltip bottom>
  <template v-slot:activator="{ on }">
    <v-btn
      class="pdy-btn"
      color="light-blue darken-1"
      dark
      large
      depressed
      v-on="on"
      @click="$refs.pdyFile.click()"
    >
      PDY Yükle (beta)
      <v-icon right>file_upload</v-icon>
    </v-btn>
  </template>
  <span>PDF / JPG / PNG yükle</span>
</v-tooltip>

<!-- Gizli dosya seçici -->
<input
  ref="pdyFile"
  type="file"
  accept=".pdf,.png,.jpg,.jpeg"
  style="display:none"
  @change="pdyFileSelected($event.target.files)"
/>



              <!-- Cift tiklama korumasi icin kaydetbutonu; :action Promise dondurur.
                   Duz v-btn ile hizli cift tikta GelenFaturaKaydet iki kez gidiyor
                   ve MUKERRER gelen fatura olusuyordu. color="" biraktik: toolbar
                   zaten koyu, bilesenin varsayilan "primary" rengi gorunumu bozuyor. -->
              <v-tooltip v-if="kaydetbuton" bottom>
                <kaydetbutonu slot="activator" :action="KaydetYeni" :disabled="!sayfayetki.Save" color="">
                  <span class="hidden-sm-and-down"> {{$t("save_button")}}
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </kaydetbutonu>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>

              <v-tooltip v-if="guncellebuton" bottom>
                <kaydetbutonu slot="activator" :action="KaydetGuncelle" :disabled="!sayfayetki.Update" color="">
                  <span class="hidden-sm-and-down"> {{ $t('Update') }}
                  </span>
                  <v-icon color="white" right dark>create</v-icon>
                </kaydetbutonu>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>


              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <!-- API'ye istek attigi icin v-list-tile degil kaydetbutonu:
                       cift tiklamada iki GelenFaturaSil istegi gidiyordu. -->
                  <v-tooltip bottom>
                    <kaydetbutonu v-if="guncellebuton" slot="activator" :action="faturasil"
                      :disabled="!sayfayetki.Delete" color="error">
                      {{ $t('Delete-Invoice') }}
                    </kaydetbutonu>
                    <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                    <span v-if="sayfayetki.Delete"> {{ $t('Delete-Invoice') }} </span>
                  </v-tooltip>


                  <v-tooltip bottom>
                    <v-list-tile v-if="guncellebuton" slot="activator" :disabled="!sayfayetki.Update"
                      @click="faturaiade()">
                      <v-list-tile-title> {{ $t('Invoice-Return') }} </v-list-tile-title>
                    </v-list-tile>
                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                    <span v-if="sayfayetki.Update">{{ $t('Invoice-Return') }}</span>
                  </v-tooltip> 


                  <a target="_self" v-bind:href="'#/coper/page/formlar/gelenfaturalistesi'">
                    <v-list-tile>
                      <v-list-tile-title>{{ $t('List-of-Invoices-Received') }} </v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
          

          <v-container fluid>
            <v-layout row wrap>

              <v-flex pa-1 xs12 sm12 md4>


                <v-flex mt-2 xs12 sm12 md12>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>

                     
                          <v-flex xs12 sm12 md12>
                            <saticiara ref="saticiara" v-model="GelenFatura.Fatura.Satici" :tip="GelenFatura.Fatura.SaticiTip" @setSeller="setSaticiTip($event)" ></saticiara>

                            <!-- Secili saticinin cari kodu. Bilgi amacli gibi duruyor ama
                                 pratik karsiligi var: satirekle() cari kod yoksa satir
                                 eklemeyi engelliyor, dolayisiyla eksiklik daha formdayken
                                 gorulmeli. Eksik durumda satirekle() ile AYNI metin
                                 gosteriliyor, yeni ceviri anahtari eklenmedi.

                                 Duz metin yerine rozet kullaniliyor: sayfanin geri kalani
                                 zaten v-chip dilini konusuyor ve bu bilginin goze carpmasi
                                 gerekiyor. Renkler acikca veriliyor, cunku ust kart
                                 class="white--text" tasiyor. pb-3 asagidaki Fatura Tipi
                                 etiketiyle arayi aciyor. -->
                            <div v-if="GelenFatura.Fatura.Satici && GelenFatura.Fatura.Satici.kod"
                              class="pl-1 pt-1 pb-3">
                              <v-chip v-if="GelenFatura.Fatura.Satici.CariKod" color="info" text-color="white"
                                class="cari-rozet">
                                <v-avatar>
                                  <v-icon color="white">account_balance</v-icon>
                                </v-avatar>
                                <!-- Iki satir: ustte hesap kodu, altta unvan. Avatarin
                                     yaninda tek oge olarak durabilmeleri icin ortak bir
                                     sutun kabindalar; .v-chip__content yatay flex. -->
                                <span class="cari-rozet-metin">
                                  <span class="cari-rozet-kod">{{ $t('Current-Account-Code') }}:&nbsp;<strong>{{ GelenFatura.Fatura.Satici.CariKod }}</strong></span>
                                  <!-- Unvan yalnizca KAYITLI faturada dolu: GetGelenFatura
                                       sorgusundaki CariHesapGenel join'inden geliyor. Ice
                                       aktarma ekraninda Satici SaticiKodAra'dan geldigi icin
                                       bos kalir; o zaman rozet tek satir olarak gorunur. -->
                                  <span v-if="GelenFatura.Fatura.CariUnvan" class="cari-rozet-unvan">{{ GelenFatura.Fatura.CariUnvan }}</span>
                                </span>
                              </v-chip>
                              <v-chip v-else color="red" text-color="white">
                                <v-avatar>
                                  <v-icon color="white">warning</v-icon>
                                </v-avatar>
                                {{ $t('seller-you-selected-does-not-have-any-current-codes') }}
                              </v-chip>
                            </div>
                            <!-- <genelarama :autofocuss="true" :rules="[v => !!v || $t('Mandatory-Areas')]"
                              v-model="GelenFatura.Fatura.Satici" apiname="SaticiAra"
                              :tip="GelenFatura.Fatura.SaticiTip" 
                              :icdis="YurtDisi"
                              :label="$t('Seller-Code')">
                            </genelarama> -->
                          </v-flex>

                          <v-flex xs12 sm6 md6>
                            <v-autocomplete :items="faturatipi" hide-details="" v-model="GelenFatura.Fatura.FaturaTip"
                              item-text="text" item-value="value" :label="$t('Invoice-Type')"></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 sm6 pl-2 md6>
                            <v-checkbox v-model="GelenFatura.Fatura.Proforma" label="Proforma" hide-details>
                            </v-checkbox>

                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-text-field v-model="GelenFatura.Fatura.Aciklama" maxlength="250" hide-details="" :label="$t('Description')"
                              value="">
                            </v-text-field>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-flex>


              <v-flex pa-1 mt-2 xs12 sm6 md4>

                <v-card flat class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-layout row wrap>

                          <v-flex xs12 sm6 md6>
                            <v-autocomplete :items="doviztipi" hide-details="" item-text="Title" item-value="DovizKod"
                              v-model="GelenFatura.Fatura.FatPara" @change="kurgetir2()" :label="$t('Invoice-Money')">
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <dovizinput v-model="GelenFatura.Fatura.FatKur" :etiket="$t('Invoice-Exchange-Rate')"
                              :autocomplete="autocomplete">
                            </dovizinput>
                          </v-flex>

                          <v-flex pt-2 xs12 sm12 md12>
                            <v-btn outline @click.native="ekstradialog=true" block color="info">  {{ $t('Extra-Details') }} 
                            </v-btn>
                          </v-flex>

                        </v-layout>

                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

              <v-flex pa-1 xs12 mt-2 sm6 md4>
                <v-flex xs12 sm12 md12>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>

                              <tarihcomp :etiket="$t('Invoice-Date')" :detaygizle="true"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="GelenFatura.Fatura.FatTarih" v-model="GelenFatura.Fatura.FatTarih">
                              </tarihcomp>


                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field :disabled="seridisable" :label="$t('Invoice-Serial-No-v2')" hide-details
                                    :rules="[v => !!v || $t('Mandatory-Areas'), () => !!GelenFatura.Fatura.FatSeri && GelenFatura.Fatura.FatSeri.length <= 3|| $t('Cannot-exceed-three-characterst')]"
                                    v-model="GelenFatura.Fatura.FatSeri"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field hide-details="" mask="##########" :disabled="seridisable"
                                    :label="$t('Invoice-No')" v-model="GelenFatura.Fatura.FatNo"
                                    :rules="[v => !!v || $t('Mandatory-Areas')]"></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <tarihcomp :etiket="$t('Maturity')" :detaygizle="true"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="GelenFatura.Fatura.VadeTarihi" v-model="GelenFatura.Fatura.VadeTarihi">
                              </tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <tarihcomp :etiket="$t('Invoice-Term-Date')" :detaygizle="true"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="GelenFatura.Fatura.HesaplananVade"
                                v-model="GelenFatura.Fatura.HesaplananVade"></tarihcomp>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field label='EvrakNo' hide-details
                                    v-model="GelenFatura.Fatura.EvrakNo"></v-text-field>
                                
                            </v-flex>

                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-flex>

            </v-layout>


            <v-flex mt-2 xs12 sm12 md12>
              <v-card color="grey lighten-5" flat="">
                <v-card-actions>
                  <v-layout row wrap>

                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>

                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap class=" project overdue">
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title> <span class="subheading black--text">
                                   {{ $t('Sales-Items') }} 
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-btn color="grey" @click="satirekle()" flat> {{ $t('Add-Item') }} 
                                <v-icon color="grey" right dark>add_box</v-icon>
                              </v-btn>
                            </v-toolbar>
                          </v-layout>
                        </v-flex>
                        <v-flex pl-2 v-if="GelenFatura.Fatura.Kalemler.length==0" xs12 sm12 md12>
                          <span class="grey--text "> {{ $t('Item-has-yet-to-be-added') }} </span>
                        </v-flex>

                        <v-flex v-for="item in GelenFatura.Fatura.Kalemler" pt-1 v-bind:key="item.id" xs12 sm12 md12>
                          <v-layout class=" project overdue">
                            <v-hover>
                              <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                                width="100%">


                                <v-list two-line="">
                                  <v-layout row wrap>
                                    <v-flex xs12 sm12 md12>
                                      <v-card flat class="black--text">
                                        <v-card flat="">
                                          <v-card-actions>
                                            <v-layout row wrap>

                                              <v-flex xs12 sm4 md2>
                                                <v-layout
                                                  v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.sm  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                                                  align-center justify-start fill-height>
                                                  <v-card flat="">
                                                      <!-- Bu sutun bilerek v-list-tile KULLANMIYOR. Kart <v-list two-line>
                                                           icinde ve Vuetify tile yuksegini sabitliyor:
                                                           .v-list--two-line .v-list__tile{height:72px} +
                                                           .v-list__tile__content{height:100%}. Rozet satiri ile birlikte uc
                                                           bilgi satiri bu yukseklige sigmayip ust uste biniyordu. Duz div
                                                           ile icerik kendi yuksekligince akiyor. -->
                                                      <div class="px-4 py-2">
                                                        <v-layout row wrap align-center justify-start>

                                                          <!-- Kalemin kendi saticisi. GetGelenFatura bu iki alani
                                                               PersonDetails uzerinden (ExIslemRef = IslemRef)
                                                               turetiyor; eslesme yoksa SaticiTip 0 gelir ve rozet
                                                               hic cizilmez. -->
                                                          <v-chip v-if="saticiRozeti(item.SaticiTip)" small=""
                                                            :color="saticiRozeti(item.SaticiTip).renk" text-color="white">
                                                            <v-avatar>
                                                              <v-icon color="white">{{ saticiRozeti(item.SaticiTip).ikon }}</v-icon>
                                                            </v-avatar>
                                                            {{ saticiRozeti(item.SaticiTip).etiket }}
                                                          </v-chip>

                                                        </v-layout>

                                                        <div class="font-weight-bold caption grey--text text--darken-2">
                                                          Pnr No:
                                                          <!-- PNR numarasi rezervasyon ekranini aciyor. E-faturadan
                                                               gelen kalemlerde PNR_No 0 oldugu icin link cizilmez;
                                                               acilacak bir rezervasyon yok. -->
                                                          <span v-if="item.PNR_No" class="pnr-link"
                                                            :title="$t('Open-Reservation')" @click="pnrAc(item)">{{item.PNR_No}}</span>
                                                          <template v-else>{{item.PNR_No}}</template>
                                                        </div>

                                                        <div class="font-weight-bold caption grey--text text--darken-2">
                                                          {{ $t('Process-Ref') }} : {{item.IslemRef}}
                                                        </div>

                                                        <div v-if="item.SaticiKod" class="font-weight-bold caption grey--text text--darken-2">
                                                          <!-- Gosterilen metin AD. Ad cozulememis kalemlerde (satici silinmis ya
                                                               da PersonDetails eslesmesi yok) kod gosteriliyor: hicbir sey
                                                               gostermemektense kaydin kimligi gorunsun.
                                                          
                                                               SaticiTip yoksa link cizilmiyor: goster.vue kaydi bulmak icin
                                                               kod VE tip ister (goster.vue:441), tipsiz adres bos ekran acar. -->
                                                          <span v-if="item.SaticiTip" class="pnr-link"
                                                            :title="$t('Open-Seller')" @click="saticiAc(item)">{{item.SaticiAd || item.SaticiKod}}</span>
                                                          <template v-else>{{item.SaticiAd || item.SaticiKod}}</template>
                                                        </div>

                                                      </div>
                                                  </v-card>
                                                </v-layout>

                                              </v-flex>


                                              <!--
                                                Tutar/KDV ve Tevkifat bloklari BIRLIKTE sariliyor ki altlarina
                                                konan aciklama ikisinin genisligini birden kaplasin.
                                              
                                                Genislikler DEGISMIYOR: eski "xs6 sm2 md2" ikilisi, sarmalayici
                                                "xs12 sm4 md4" + ic "xs6 sm6 md6" olunca ayni yerlere denk
                                                geliyor (sm4'un yarisi = sm2).
                                              -->
                                              <!--
                                                Tutar/KDV, Tevkifat ve Stopaj bloklari BIRLIKTE sariliyor ki
                                                altlarina konan aciklama UCUNUN genisligini birden kaplasin.
                                              
                                                Genislikler DEGISMIYOR: eski "xs6 sm2 md2" ucluisu, sarmalayici
                                                "xs12 sm6 md6" + ic "xs4 sm4 md4" olunca ayni yerlere denk
                                                geliyor (sm6'nin ucte biri = sm2).
                                              -->
                                              <v-flex xs12 sm6 md6>
                                                <v-layout row wrap>
                                                <v-flex xs4 sm4 md4>
                                                  <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                      <v-layout align-start="" justify-start fill-height>
                                                        <v-card flat="">
                                                          <v-list-tile>
                                                            <v-list-tile-content style="'overflow=inherit';">
  
                                                              <v-list-tile-sub-title>
                                                                <div class="font-weight-bold caption ">
                                                                  {{ $t('Amount') }}
                                                                </div>
                                                              </v-list-tile-sub-title>
  
  
                                                              <v-list-tile-sub-title>
                                                                <div class="font-weight-bold caption ">
                                                                   {{ $t('VAT-Amount') }} :
                                                                </div>
                                                              </v-list-tile-sub-title>
  
                                                              
  
  
                                                            </v-list-tile-content>
                                                          </v-list-tile>
                                                        </v-card>
                                                      </v-layout>
                                                    </v-flex>
  
                                                    <v-flex xs12 sm6 md6>
                                                      <v-layout row justify-end="" fill-height>
                                                        <!--
                                                          kalem-degerleri: karti kuculebilir yapar.
                                                          Kart bir flex ogesi ve overflow:visible
                                                          oldugu icin min-width:auto aliyor, yani
                                                          iceriginin altina kuculmuyor ve uzun bir
                                                          deger flex'in disina tasiyor. Aciklama
                                                          buradayken tam da bu oluyordu; artik
                                                          asagida ayri satirda ama kural duruyor,
                                                          uzun bir tutar de ayni sekilde tasirdi.
                                                        -->
                                                        <v-card flat="" class="kalem-degerleri">
                                                          <v-list-tile>
                                                            <v-list-tile-content>
  
                                                              <v-list-tile-sub-title>
                                                                <v-layout align-center="" justify-end>
                                                                  <div class="font-weight-  caption ">
                                                                    {{item.Tutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}</div>
                                                                </v-layout>
                                                              </v-list-tile-sub-title>
  
  
                                                              <v-list-tile-sub-title>
                                                                <v-layout align-center="" justify-end>
                                                                  <div class="font-weight-  caption ">
                                                                    {{item.KDVTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                                  </div>
                                                                </v-layout>
                                                              </v-list-tile-sub-title>
  
                                                            </v-list-tile-content>
                                                          </v-list-tile>
                                                        </v-card>
                                                      </v-layout>
                                                    </v-flex>
                                                  </v-layout>
  
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                  <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                      <v-layout align-start="" justify-start fill-height>
                                                        <v-card flat="">
                                                          <v-list-tile>
                                                            <v-list-tile-content style="'overflow=inherit';">
  
                                                              <v-list-tile-sub-title>
                                                                <div class="font-weight-bold caption ">
                                                                   {{ $t('Deduction-Rate')  }} :
                                                                </div>
                                                              </v-list-tile-sub-title>
  
                                                              <v-list-tile-sub-title>
                                                                <div class="font-weight-bold  caption">
                                                                  {{  $t('Deduction-Amount') }}
                                                                </div>
                                                              </v-list-tile-sub-title>
  
                                                            </v-list-tile-content>
                                                          </v-list-tile>
                                                        </v-card>
                                                      </v-layout>
                                                    </v-flex>
  
                                                    <v-flex xs12 sm6 md6>
                                                      <v-layout row justify-end="" fill-height>
                                                        <v-card flat="">
                                                          <v-list-tile>
                                                            <v-list-tile-content>
  
                                                              <v-list-tile-sub-title>
                                                                <v-layout align-center="" justify-end>
                                                                  <div class="font-weight-  caption ">
                                                                    {{item.TevkifatOran | orangoster}}%</div>
                                                                </v-layout>
                                                              </v-list-tile-sub-title>
  
                                                              <v-list-tile-sub-title>
                                                                <v-layout align-center="" justify-end="">
                                                                  <div class="font-weight-  caption ">
                                                                    {{item.TevkifatTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                                  </div>
                                                                </v-layout>
                                                              </v-list-tile-sub-title>
  
  
                                                            </v-list-tile-content>
                                                          </v-list-tile>
                                                        </v-card>
                                                      </v-layout>
                                                    </v-flex>
                                                  </v-layout>
  
                                                </v-flex>

                                                <v-flex xs4 sm4 md4>
                                                <v-layout>
                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout align-start="" justify-start fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content style="'overflow=inherit';">

                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold caption ">
                                                                 {{ $t('Withholding-Rate') }} :
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <div class="font-weight-bold  caption">
                                                                {{ $t('Withholding-Amount') }}
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>

                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout row justify-end="" fill-height>
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content>



                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end>
                                                                <div class="font-weight-  caption ">
                                                                  {{item.StopajOran | moneyformat}}%</div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <v-layout align-center="" justify-end="">
                                                                <div class="font-weight-  caption ">
                                                                  {{item.StopajTutar | moneyformat }}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>




                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                                </v-flex>
                                                </v-layout>

                                              <!--
                                                Aciklama, ustteki UC BLOGUN (tutar/KDV, tevkifat ve stopaj)
                                                genisligini birden kaplar. Tek blok genisliginde cok dar
                                                kaliyordu; metnin neredeyse tamami kirpiliyordu.
                                              
                                                Yan bosluk 16px: v-list-tile'in kendi padding'i bu, aciklama
                                                ustteki etiketlerle hizali dursun diye.
                                              -->
                                              <div
                                                v-if="item.Aciklama"
                                                class="kalem-aciklama caption"
                                                :title="item.Aciklama"
                                              >
                                                {{item.Aciklama}}
                                              </div>
                                              </v-flex>

                                              <v-flex xs12 sm4 md2>
                                                <v-layout row align-center justify-center="" fill-height="">
                                                  <v-card flat="">
                                                    <v-list-tile>
                                                      <v-list-tile-content>
                                                        <v-layout row wrap justify-center="">
                                                          <v-list-tile-title>
                                                            <v-layout row wrap justify-center="">
                                                              KDV'li Tutar
                                                            </v-layout>
                                                          </v-list-tile-title>
                                                          <v-list-tile-sub-title>
                                                            <v-layout row wrap justify-end="">
                                                              <div class="red--text subheading">
                                                                {{item.KDVliTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}

                                                              </div>
                                                            </v-layout>

                                                          </v-list-tile-sub-title>
                                                          <v-list-tile-title>
                                                            <v-layout row wrap justify-center="">
                                                              <div class="font-weight green--text caption ">
                                                                % {{item.KDVYuzde | moneyformat}} {{ $t('VAT') }}
                                                              </div>
                                                            </v-layout>

                                                          </v-list-tile-title>
                                                        </v-layout>
                                                      </v-list-tile-content>

                                                    </v-list-tile>
                                                  </v-card>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs12 sm4 md2>
                                                <v-card flat="">
                                                  <v-layout row wrap align-center="" justify-end="" fill-height="">


                                                    <v-flex xs2 sm2 md2>
                                                      <v-tooltip slot="append" bottom>
                                                        <v-btn slot="activator" icon class="mx-0"
                                                          @click="satirsil(item)">
                                                          <v-icon color="red">delete</v-icon>
                                                        </v-btn>
                                                        <span> {{ $t('Delete') }} </span>
                                                      </v-tooltip>
                                                    </v-flex>

                                                    <v-flex xs2 sm2 md2>
                                                      <v-tooltip slot="append" bottom>
                                                        <v-btn slot="activator" icon class="mx-0"
                                                          @click="satirduzenle(item)">
                                                          <v-icon color="green">edit</v-icon>
                                                        </v-btn>
                                                        <span>Düzenle</span>
                                                      </v-tooltip>
                                                    </v-flex>


                                                  </v-layout>

                                                </v-card>
                                              </v-flex>

                                              <!--
                                    <v-flex xs12 sm4 md2>
                                      <v-card flat="">
                                        <v-layout row wrap align-center="" justify-start="" fill-height="">




                                          <v-flex xs12 sm2 md2>
                                            <v-tooltip slot="append" bottom>
                                              <v-btn small v-if="item.GenelBilgileri.FaturaTip!='0'" slot="activator"
                                                icon class="mx-0"
                                                @click="efaturagoster(item.GenelBilgileri.EFaturaShowID.EFaturaGuid,item.GenelBilgileri.EFaturaShowID.EFaturaID)">
                                                <v-icon color="info">line_weight</v-icon>
                                              </v-btn>
                                              <span>E-Fatura</span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex xs12 sm2 md2>
                                            <v-tooltip slot="append" bottom>
                                              <v-btn small icon slot="activator" class="mx-0"
                                                @click="reportbrobas(item.GenelBilgileri.EFaturaShowID.EFaturaGuid,item.GenelBilgileri.EFaturaShowID.EFaturaID,item.GenelBilgileri.EFaturaShowID.PdfID)">
                                                <v-icon color="info">print</v-icon>
                                              </v-btn>
                                              <span>{{ $t('Print') }}</span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex
                                            v-if="(item.GenelBilgileri.FaturaTip=='1' || item.GenelBilgileri.FaturaTip=='2') &&item.GenelBilgileri.EFaturaShowID.FaturaStatus=='Fatura Beklemede'"
                                            xs12 sm2 md2>
                                            <v-tooltip bottom>
                                              <v-btn small icon :disabled="!sayfayetki.Update" slot="activator"
                                                @click="OnayaGonderTekli(item)" flat>
                                                <v-icon color="info" dark>check</v-icon>
                                              </v-btn>
                                              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}( {{ $t('Send-for-Approval') }} )</span>
                                              <span v-if="sayfayetki.Update"> {{ $t('Send-for-Approval') }} </span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex v-if="item.GenelBilgileri.Tip=='SER'" xs12 sm2 md2>
                                            <v-tooltip bottom>
                                              <v-btn small icon :disabled="!sayfayetki.Update" slot="activator"
                                                @click="git(item.GenelBilgileri)" flat>
                                                <v-icon color="info" dark>edit</v-icon>
                                              </v-btn>
                                              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                              <span v-if="sayfayetki.Update">Düzenle</span>
                                            </v-tooltip>
                                          </v-flex>

                                          <v-flex xs12 sm2 md2>
                                            <v-tooltip slot="append" bottom>
                                              <a target="_blank" small slot="activator"
                                                v-bind:href="'#/fatura/faturadetay/id?' + 'guid=' + item.GenelBilgileri.EFaturaShowID.EFaturaGuid">
                                                <v-btn small icon>
                                                  <v-icon color="info">search</v-icon>
                                                </v-btn>
                                              </a>
                                              <span>{{ $t('Content') }}</span>
                                            </v-tooltip>
                                          </v-flex>

                                        </v-layout>

                                      </v-card>
                                    </v-flex> -->

                                            </v-layout>
                                          </v-card-actions>
                                        </v-card>
                                      </v-card>
                                    </v-flex>
                                  </v-layout>

                                </v-list>
                              </v-card>
                            </v-hover>
                          </v-layout>
                        </v-flex>

                      </v-layout>
                    </v-flex>

                  </v-layout>

                </v-card-actions>
              </v-card>
            </v-flex>


          </v-container>

          <v-container fluid>
            <v-layout>
              <v-flex xs12 sm12 md12>
                <v-layout justify-end="" row>
                  <v-flex xs12 sm12 md4>
                    <v-card flat class="white--text">
                      <v-layout class=" project overdue">
                        <v-flex xs2 sm2 md2>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <v-icon color="info" large="">queue</v-icon>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm10 md10>

                          <v-card-title primary-title="">

                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                      Matrah
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>

                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span class="subheading grey--text font-weight-">
                                        {{GelenFatura.Fatura.ToplamTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}

                                      </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                        {{ $t('Total-VAT') }}
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span class="subheading grey--text font-weight-">
                                        {{GelenFatura.Fatura.ToplamKDVTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}} </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                        {{  $t('Deduction-Amount') }}
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span class="subheading grey--text font-weight-">
                                        {{GelenFatura.Fatura.ToplamTevkifatTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                      </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-divider></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                       {{ $t('Invoice-Amount') }} 
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-">
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span class="subheading grey--text font-weight-">
                                        {{GelenFatura.Fatura.FaturaNetTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}} </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-card-title>
                        </v-flex>
                      </v-layout>

                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

          </v-container>



        </v-layout>
      </v-card>
    </v-form>



    <v-dialog v-model="ekstradialog" scrollable="" persistent max-width="350px">
      <v-card>
        <v-card-title> {{ $t('Extra-Details') }}  </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">
            <v-flex xs12 sm6 md6>
              <v-autocomplete :items="doviztipi" hide-details="" item-text="Title" item-value="DovizKod"
                v-model="GelenFatura.Fatura.SatisPara" @change="kurgetir()" :label="$t('Sales-Money')">
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <dovizinput v-model="GelenFatura.Fatura.SatisKur" :etiket="$t('Sales-Currency')" ::autocomplete="autocomplete">
              </dovizinput>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <genelarama
                  v-model="GelenFatura.Fatura.MasrafMrkz2"
                   apiname="MasrafMerkeziAra"
                   :label="$t('Expense-Center-v2')"
                ></genelarama>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <muhasebefistipara :etiket="$t('Accounting-Bill-Type')" v-model="GelenFatura.Fatura.MuhasebeFisTipi">
              </muhasebefistipara>

            </v-flex>

            <v-flex pb-3 xs12 sm12 md12>
              <geneltipara tip="CariTransferKod" v-model="GelenFatura.Fatura.TransferKod"></geneltipara>

            </v-flex>

          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="ekstradialog=false">{{ $t('OK') }}</v-btn>



        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="satirdialog" scrollable="" persistent="" max-width="850px">
      <v-card color="grey lighten-5">
        <v-card-title> {{ $t('Line-Entry') }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">
            <v-flex v-if="!kalemkayitvarmi" xs12 sm12 md12>
              <v-alert type="error" value="true">
                <span> Kayıt bulunamadı</span>

              </v-alert>
            </v-flex>

            <v-flex xs12 pb-2 sm12 md12>
              <v-card flat class="white--text">
                <v-card flat="">
                  <v-card-actions>

                    <v-layout row wrap>

                      <v-flex xs12 sm12 md12>
                        <pnrbul :satici="GelenFatura.Fatura.Satici"
                          :tip="GelenFatura.Fatura.SaticiTip" v-model="SatirGelenFatura.PnrNo">
                        </pnrbul>
                      </v-flex>

                      <v-flex xs12 sm12 md8>
                        <v-radio-group hide-details v-model="pnrtip">
                          <v-radio :label="pnretiket" :value="true"></v-radio>
                          <v-radio :label="$t('Select-all-Pnr')" :value="false"></v-radio>
                        </v-radio-group>
                      </v-flex>


                      <v-flex xs12 sm4 pt-3 md4>
                        <v-layout row fill-height justify-end full-width align-end="">
                          <v-btn v-if="!pnrkalemloading" @click="kalemGetir();" outline color="info"> {{ $t('List-Items') }} 
                          </v-btn>
                          <v-layout v-if="pnrkalemloading" row fill-height justify-end full-width align-end="">
                            <v-progress-circular indeterminate :width="4" color="info"></v-progress-circular>

                          </v-layout>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>




            <v-flex xs12 0sm12 v-if="itemsgelen.length!=0" md12>
              <v-card flat class="white--text">
                <v-card flat="">
                  <v-card-actions>

                    <v-layout row wrap>


                      <v-flex xs12 sm6 md6>
                        <yuzdeinput v-model="SatirGelenFatura.KDVYuzde" :etiket="'KDV %'"></yuzdeinput>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <div></div>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" @odakkaybi="tutarblur"
                          v-model="SatirGelenFatura.Tutar" :etiket="$t('Amount-without-VAT')" :autocomplete="autocomplete">
                        </parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)"
                          v-model="SatirGelenFatura.KDVTutar" :etiket="$t('VAT-Amount')" :autocomplete="autocomplete">
                        </parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <v-select :items="Tevkifat" hide-details="" item-text="text" item-value="value"
                          v-model="SatirGelenFatura.TevkifatOran" @change="Tevkifatkdvhesapla()"
                          :label="$t('Deduction-Rate')"></v-select>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" v-model="SatirGelenFatura.TevkifatTutar"
                          :etiket="$t('Deduction-Amount')" :autocomplete="autocomplete"></parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <yuzdeinput v-model="SatirGelenFatura.StopajOran" :etiket="'Stopaj Oranı'"></yuzdeinput>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" @odakkaybi="stopajtutarblur"
                          v-model="SatirGelenFatura.StopajTutar" :etiket="$t('Withholding-Amount')" :autocomplete="autocomplete">
                        </parainputevents>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-text-field v-model="SatirGelenFatura.Aciklama" maxlength="100" counter="100"
                          :label="$t('Description')"></v-text-field>
                      </v-flex>

                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          
            <v-flex xs12 v-if="itemsgelen.length!=0" pt-2 sm12 md12>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-layout row wrap class=" project overdue">
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title> <span class="subheading black--text">
                          Kalemler
                        </span> </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>


                <v-flex v-for="item in itemsgelen" pt-1 v-bind:key="item.id" xs12 sm12 md12>
                  <v-hover>

        

                    <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">

                    
                      <v-list three-line="">
                       
                        <v-layout row wrap>
                       
                          <v-flex xs1 sm1 md1>
                            &nbsp;
                          </v-flex>
                          
                          <v-flex pl-4 xs11 sm11 md11>

                            <v-tooltip bottom>
                            <template v-slot:activator="{ on }">

                            <!-- Satici tipi rozeti. Onceden 15 ayri v-chip v-if blogu vardi
                                 (~120 satir). Ikon/renk/etiket artik saticiRozeti() haritasindan
                                 geliyor; harita bu bloktan birebir cikarilmisti, dolayisiyla
                                 gorunum degismiyor. Kalem listesindeki rozet de ayni kaynagi
                                 kullaniyor, iki listede ayni satici ayni gorunuyor.
                                 Haritada olmayan tip (0 = eslesme yok, 16 = burada da
                                 karsiligi yoktu) null doner ve rozet cizilmez. -->
                            <v-chip v-on="on" v-if="saticiRozeti(item.SaticiTip)" small=""
                              :color="saticiRozeti(item.SaticiTip).renk" text-color="white">
                              <v-avatar>
                                <v-icon color="white">{{ saticiRozeti(item.SaticiTip).ikon }}</v-icon>
                              </v-avatar>
                              {{ saticiRozeti(item.SaticiTip).etiket }}
                            </v-chip>

                            <!-- Asagidaki iki rozet tip bazli DEGIL: kalemin, faturanin saticisiyla
                                 eslesip eslesmedigini gosteriyor. Farkli bir soru oldugu icin
                                 haritaya girmiyorlar, oldugu gibi biraktilar. -->
                            <v-chip v-on="on" small="" v-if="item.SaticiTip==1 && item.SaticiKod== GelenFatura.Fatura.Satici.kod"
                              color="white" text-color="green">
                              <v-avatar>
                                <v-icon color="green">check_circle_outline</v-icon>
                              </v-avatar>
                               {{ $t('Relevant-Seller') }} 
                            </v-chip>

                            <v-chip  v-on="on" small=""
                              v-if="GelenFatura.Fatura.SaticiTip==12 && item.TurOperatoru== GelenFatura.Fatura.Satici.kod"
                              color="white" text-color="green">
                              <v-avatar>
                                <v-icon color="green">check_circle_outline</v-icon>
                              </v-avatar>
                               {{ $t('Relevant-Sales-Operator') }} 
                            </v-chip>

                            </template>
                              <span>{{ item.KisiIsim }}</span>
                            </v-tooltip>

                            <span class="font-weight-bold grey--text  body-1 "> {{$t('Seller')}}:
                            </span> {{item.SaticiKod}}-{{item.SaticiAd}}
                            - <span class="font-weight-bold grey--text body-1 "> {{ $t('Operator-Code') }} :
                            </span>{{item.TurOperatoru}}
                        
                          </v-flex>
                          
                        </v-layout>
     
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-card flat="">
                                <v-card-actions>
                                  <v-layout row wrap>
                                    <v-list-tile>
                                      <v-list-tile-content>
                                        <v-layout justify-start="" align-start>
                                          <v-flex xs1 sm1 md1>
                                            <v-checkbox hide-details="" v-model="secilenkayitlar" :value="item">
                                            </v-checkbox>
                                          </v-flex>
                                        </v-layout>
                                      </v-list-tile-content>
                                    </v-list-tile>




                                    <v-flex xs12 sm4 md2>
                                      <v-layout justify-start="" row align-center="">
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout justify-start="" align-center="">

                                                <v-flex>

                                                  <v-list-tile-sub-title>
                                                    <v-layout justify-start="" align-center>
                                                      <div class="font-weight- red--text subheading ">
                                                        {{item.Donem1 | dateformat}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout justify-start="" align-center>
                                                      <div class="font-weight- red--text subheading ">
                                                        {{item.Donem2 | dateformat}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>




                                    <v-flex xs6 sm3 md3>
                                      <v-layout>
                                        <v-flex xs12 sm6 md8>
                                          <v-layout align-start="" justify-start fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content style="'overflow=inherit';">

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold caption ">
                                                      {{ $t('Amount') }}
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold  caption">
                                                      {{ $t('VAT') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold caption ">
                                                      {{ $t('VAT-Amount') }} :
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold  caption">
                                                      KDV'li Tutar
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm6 md4>
                                          <v-layout row justify-end="" fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end>
                                                      <div class="font-weight-  caption ">
                                                        {{item.Tutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}</div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end="">
                                                      <div class="font-weight-  caption ">
                                                        {{item.KDVYuzde | moneyformat}}%
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end>
                                                      <div class="font-weight-  caption ">
                                                        {{item.KDVTutar | moneyformat }}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}</div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end="">
                                                      <div class="font-weight-  caption ">
                                                        {{item.KDVliTutar| moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>




                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>


                                    <v-flex xs6 sm3 md3>
                                      <v-layout>
                                        <v-flex xs12 sm6 md8>
                                          <v-layout align-start="" justify-start fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content style="'overflow=inherit';">

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold caption ">
                                                       {{ $t('Deduction-Rate') }} :
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold  caption">
                                                        {{  $t('Deduction-Amount') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold caption ">
                                                      {{ $t('Withholding-Rate') }} :
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div class="font-weight-bold  caption">
                                                      {{ $t('Withholding-Amount') }}
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm6 md4>
                                          <v-layout row justify-end="" fill-height>
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end>
                                                      <div class="font-weight-  caption ">
                                                        {{item.TevkifatOran | orangoster}}%</div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end="">
                                                      <div class="font-weight-  caption ">
                                                        {{item.TevkifatTutar | moneyformat }}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end>
                                                      <div class="font-weight-  caption ">
                                                        {{item.StopajOran | moneyformat}}%</div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout align-center="" justify-end="">
                                                      <div class="font-weight-  caption ">
                                                        {{item.StopajTutar | moneyformat}}{{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>




                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm4 md2>
                                      <v-layout row align-center justify-center="" fill-height="">
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout row wrap justify-center="">
                                                <v-list-tile-title>
                                                  <v-layout row wrap justify-center="">
                                                    {{ $t('Cost') }}
                                                  </v-layout>
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                  <v-layout row wrap justify-end="">
                                                    <div class="red--text subheading">
                                                      {{item.KalemMaliyet | moneyformat }}
                                                      {{getparabirimiDefault(GelenFatura.Fatura.FatPara)}}
                                                    </div>
                                                  </v-layout>

                                                </v-list-tile-sub-title>
                                                <v-list-tile-title>
                                                  <v-layout row wrap justify-center="">
                                                    <div class="font-weight green--text caption ">

                                                    </div>
                                                  </v-layout>

                                                </v-list-tile-title>
                                              </v-layout>
                                            </v-list-tile-content>

                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>




                                  </v-layout>
                                </v-card-actions>
                              </v-card>
                            </v-card>
                          </v-flex>
                        </v-layout>
                  
                      </v-list>
                 
                    </v-card>
                  
                  </v-hover>
                </v-flex>

              </v-layout>
            </v-flex>

          </v-layout>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="satirdialog=false">{{$t("cancel_button")}}</v-btn>

          <v-btn v-if="satirkaydetbuton" :disabled="itemsgelen.length==0" color="blue darken-1" flat
            @click.native="satirkaydet()">{{ $t('OK') }}</v-btn>

          <v-btn v-if="satirguncellebuton" color="blue darken-1" flat @click.native="satirguncellekaydet()">{{ $t('Update') }}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="kalemdialog" v-if="kalemdialog" scrollable="" persistent="" max-width="500px">
      <v-card color="grey lighten-5">
        <v-card-title>Kalem Düzenle</v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">


            <v-flex xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-card flat="">
                  <v-card-actions>

                    <v-layout row wrap>

                      <v-flex xs12 sm6 md6>
                        <pnrbul v-bind:active="true" v-model="Kalem.PNR_No"></pnrbul>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" v-model="Kalem.Tutar" :etiket="$t('Amount')"
                          :autocomplete="autocomplete">
                        </parainputevents>
                      </v-flex>
                      <v-flex xs12 sm6 md6>

                        <!-- Konaklama vergisi satirinda KDV olmaz. "aktif" bu bilesenlerde
                             disabled anlamina geliyor (:disabled="Boolean(aktif)"), yani
                             true verilince alan kapaniyor. -->
                        <yuzdeinput v-model="Kalem.KDVYuzde" :etiket="$t('VAT')"
                          :aktif="Kalem.KonaklamaVergiSatiri"></yuzdeinput>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" v-model="Kalem.KDVTutar" :etiket="$t('VAT-Amount')"
                          :aktif="Kalem.KonaklamaVergiSatiri"
                          :autocomplete="autocomplete"></parainputevents>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <!-- Konaklama vergisi satirinda tevkifat/stopaj da olmaz. v-select
                             kendi disabled prop'unu tasiyor; asagidaki ozel bilesenlerde
                             ise pasiflestiren prop "aktif" (:disabled="Boolean(aktif)"). -->
                        <v-select :items="Tevkifat" hide-details="" item-text="text" item-value="value" clearable
                          v-model="Kalem.TevkifatOran" @change="Tevkifatkdvhesapla()" :label="$t('Deduction-Rate')"
                          :disabled="Kalem.KonaklamaVergiSatiri">
                        </v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" v-model="Kalem.TevkifatTutar"
                          :aktif="Kalem.KonaklamaVergiSatiri"
                          :etiket="$t('Deduction-Amount')" :autocomplete="autocomplete"></parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <yuzdeinput v-model="Kalem.StopajOran" :etiket="'Stopaj Oranı'"
                          :aktif="Kalem.KonaklamaVergiSatiri"></yuzdeinput>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents :simge="getparabirimiDefault(GelenFatura.Fatura.FatPara)" v-model="Kalem.StopajTutar" :etiket="$t('Withholding-Amount')"
                          :aktif="Kalem.KonaklamaVergiSatiri"
                          :autocomplete="autocomplete"></parainputevents>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <!-- E-faturadan gelen kalemlerde bu isaret XML'deki 0059 (konaklama
                             vergisi) vergi kodundan otomatik doluyor. Kutu, elle eklenen
                             kalemlerde isaretlemeye ve yanlis gelen kalemleri duzeltmeye
                             yariyor. Kalem listesindeki rozet bu alani okuyor. -->
                        <v-checkbox v-model="Kalem.KonaklamaVergiSatiri" :label="$t('Accommodation-Tax')"
                          @change="konaklamaVergileriSifirla" hide-details></v-checkbox>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-text-field v-model="Kalem.Aciklama" maxlength="100" counter="100"
                          :label="$t('Description')"></v-text-field>
                      </v-flex>


                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>




          </v-layout>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="kalemdialog=false">{{$t("cancel_button")}}</v-btn>
          <v-btn color="blue darken-1" flat @click.native="kalemguncellekaydet()">{{ $t('Update') }}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>






<!-- PDY: Yükleme Modal -->
<!-- PDY: Yükleme/işleme diyaloğu -->
<v-dialog v-model="pdy.loading" hide-overlay persistent max-width="520">
  <v-card>
    <v-card-text class="pt-4">
      <div class="subtitle-1 mb-3">Dosya işleniyor..</div>
      <v-progress-linear
        :indeterminate="true"
        :active="pdy.loading"
        color="info">
      </v-progress-linear>
    </v-card-text>
  </v-card>
</v-dialog>

<!-- PDY: BETA uyarısı -->
<v-dialog v-model="pdyDoneDialog" max-width="520" persistent>
  <v-card>
    <v-card-title class="headline">Fatura yükleme (beta)</v-card-title>
    <v-card-text>
      Fatura yükleme <strong>beta</strong> aşamasındadır. Lütfen bilgileri kontrol ettikten sonra kaydedin.
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="pdyDoneDialog=false">İptal</v-btn>
      <v-btn color="primary" dark @click="onPDYConfirm">Tamam</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>



    <v-dialog v-model="loadingdialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('Your-process-progress') }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>



  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import parainputevents from '../customcomp/parainputevents'
  import dovizinput from '../customcomp/dovizinput'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import tarihcomp from '../customcomp/tarihim'
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import geneltiplist from "@/components/app/customcomp/geneltiplist.vue"
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"
  import rez from "../coper/rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import muhasebefistipara from "@/components/app/coper/component/muhasebefistipara.vue";
  import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
  import tool from "../coper/tools";
  import saticiara from "@/components/app/coper/comp/saticiara.vue"
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  import kaydetbutonu from "@/components/app/customcomp/kaydetbutonu.vue";

  export default {
    props: {
      operation: ''
    },

    data() {
      return {
  pdy: { loading: false, progress: 0, done: false },
    pdyDoneDialog: false,
        uuid:null,
        pnrno:0,
        kalemkayitvarmi: true,
        pnrkalemloading: false,
        pnretiket: null,
        pnrtip: true,
        islemtipi: 0,
        duzenlenenkayitindex: -1,
        kalemdialog: false,
        secilenkayitlar: [],
        itemsgelen: [],
        itemssaticitip: rez.SaticiTip,
        YurtDisi:false,
        GelenFatura: {
          KayitTipi: 1,
          Fatura: {
            SaticiTip: 1,
            SaticiKod: null,
            // Satici carisinin unvani; API kayitli faturayi acarken dolduruyor.
            // Ice aktarma ekraninda bos kalir, rozette yalnizca kod gorunur.
            CariUnvan: null,
            FatSeri: null,
            FatNo: null,
            FatTarih: null,
            FatPara: 'TL',
            FatKur: 1,
            SatisPara: 'TL',
            SatisKur: 1,
            VadeTarihi: null,
            HesaplananVade: null,
            EvrakNo:null,
            FaturaTip: 0,
            MasrafMrkz: null,
            MasrafMrkz2: null,
            
            Proforma: false,
            Aciklama: null,
            MuhasebeFisTipi: {
              id: null,
              kod: null,
              isim: null,
              tip: null
            },
            TransferKod: {
              id: null,
              kod: null,
              isim: null,
              tip: null
            },
            Kalemler: [],

            ToplamTuta: 0,
            ToplamKDVliTutar: 0,
            ToplamKDVTutar: 0,
            ToplamTevkifatTutar: 0,
            ToplamStopajTutar: 0,
            FaturaNetTutar: 0,
            Satici: {
              id: null,
              kod: null,
              isim: null,
              tip: null,
              YurtIci_YurtDisi: 0,
              CariKod: null,
              KDV: 0,
            }
          },
          EskiFatura: {
            SaticiTip: null,
            SaticiKod: null,
            FatSeri: null,
            FatNo: null,
            FatTarih: null,
          }
        },

        SatirGelenFatura: {
          PnrNo: null,
          Aciklama: null,
          KDVYuzde: 0,
          Tutar: 0,
          KDVTutar: 0,
          KDVliTutar: 0,
          TevkifatTutar: 0,
          TevkifatOran: 0,
          StopajTutar: 0,
          StopajOran: 0,
          MatrahToplam: 0,
          TutarToplam: 0,
          KDVToplam: 0,
          TevkifatToplam: 0
        },
        Kalem: {
          KDVYuzde: 0,
          Tutar: 0,
          KDVliTutar: 0,
          KDVTutar: 0,
          PNR_No: null,
          TevkifatOran: 0,
          TevkifatTutar: 0,
          StopajOran: 0,
          StopajTutar: 0,
          IslemRef: null,
          Aciklama: null,
          KonaklamaVergiSatiri: false,
          SaticiTip: 0,
          SaticiKod: null,
        },
        kodmesajı: null,
        progress: false,
        items: [],
        dialog: false,


        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },




        headers: [{
            text: 'Muh. Kod',
            value: 'MuhasebeKodu'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama',

          },
          {
            text: this.$t('Reference'),
            value: 'Referans.Kod'
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
          },
          {
            text: this.$t('Currency-Amount'),
            value: 'DovizTutar',
          },
          {
            text: this.$t('VAT-Percentage-v2'),
            value: 'KdvYuzde',
          },
          {
            text: this.$t('VAT-Amount'),
            value: 'KdvTutar',
          },
          {
            text: this.$t('Type'),
            value: 'Tip',
          },
          {
            text: this.$t('Discount-Percentage'),
            value: 'IskontoYuzde',
          },
          {
            text: this.$t('Process'),
            value: '',
          }
        ],
        validform: true,
        autocomplete: 'autocomplete',
        Code: '',
        secilensatirno: -1,
        loading: false,

        SerbestFatura: {
          FaturaTip: 0, // 0 : Satış faturası , 1 : Iade Faturası
          Tutarlar: {
            ToplamTutar: 0,
            Iskonto: 0,
            FaturaToplam: 0,
            Kdv: 0,
            TevkifatKdv: 0
          },
        },
        SerbestFaturaDetayList: [],

        SerbestFaturaDetay: {
          MuhasebeKodu: '',
          Aciklama: '',
          LineNote: '',
          Referans: {
            Kod: ''
          },
          Masraf: {
            Code: ''
          },
          Miktar: 0,
          Birim: '',
          BirimFiyat: 0,
          Tutar: 0,
          DovizTutar: 0,
          IskontoYuzde: 0,
          IskontoTutar: 0,
          KdvTip: 'D',
          KdvYuzde: 0,
          KdvTutar: 0,
          KdvMuhKodu: '',
          IskMuhKodu: '',
          KdvKodu: '',
          IstisnaKodu: '',
          TevkifatKodu: '',
          Tip: '',
          TevkifatDetayTutar: 0,
          TevkifatDetayOran: 0,

          TeslimBilgileri: {
            SokakAdi: '',
            BinaAdi: '',
            BinaNo: '',
            TeslimSehir: '',
            TeslimPostaKodu: '',
            TeslimUlke: '',
            TeslimSarti: '',
            GTIPNo: '',
            TransferKodu: '',
            KabinNo: '',
            KabinAdedi: '',
            KabinCinsi: '',
            TeslimOdeme: ''
          }

        },




        faturatipi: [{
            text: this.$t('Purchase-Expense'),
            value: 0
          },
          {
            text: this.$t('Sales-Return'),
            value: 1
          },
          {
            text: this.$t('Advance'),
            value: 2
          },
          {
            text: this.$t('Self-employed-Receipt'),
            value: 3
          },
          {
            text: this.$t('Note-of-Expenses'),
            value: 4
          },
          {
            text: this.$t('Withholding-Donation-Receipt'),
            value: 5
          }
        ],

        seridisable: false,
        date: null,
        menu: false,

        yedeksatirkayit: {
          Tutar: 0,
          Kdv: 0,
          Tevkifat: 0,
          iskonto: 0
        },
        satirdialog: false,
        satiritems: [],
        Tevkifat: [{
            text: '0/10',
            value: 0
          },
          {
            text: '1/10',
            value: 0.1
          },
          {
            text: '2/10',
            value: 0.2
          },
          {
            text: '3/10',
            value: 0.3
          },
          {
            text: '4/10',
            value: 0.4
          },
          {
            text: '5/10',
            value: 0.5
          },
          {
            text: '6/10',
            value: 0.6
          },
          {
            text: '7/10',
            value: 0.7
          },
          {
            text: '8/10',
            value: 0.8
          },
          {
            text: '9/10',
            value: 0.9
          },
          {
            text: '10/10',
            value: 1
          }
        ],





        doviztipi: [],



        dictionary: {
          custom: {
            faturaseri: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            faturano: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },

            dizayn: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            xslt: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            gtip: {
              min: () => this.$t('Must-least-4-digits'),
            }

          }
        },
        sayfabaslik: 'Coper Gelen Fatura',
        satirguncellebuton: false,
        satirkaydetbuton: true,
        kaydetbuton: true,
        guncellebuton: false,
        text1: '',

        loadingdialog: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        active: '',
        ekstradialog: false,

      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.sayfayetki.Status = true
      this.sayfayetki.Save = true
      this.sayfayetki.Update = true
      this.sayfayetki.Delete = true

      if (this.sayfayetki.Status == true) {
        this.SerbestFaturaDetayList = []

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params1 = {
          CompanyCode: credentials.SirketKodu,
        }

        this.$http.post(auth.API_URL + 'api/currency/List', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.doviztipi = response.body
        }, (response) => {
          this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
          this.snackbar = true
        })



        if (this.$route.query.islem == "yeni") {
          this.sayfabaslik = 'Coper Gelen Fatura'
          this.guncellebuton = false
          this.kaydetbuton = true
          this.islemtipi = 1

          if(this.$route.query.uuid != null )
          {
            this.uuid = this.$route.query.uuid;
            this.pnrno = this.$route.query.pnrno;
            
            this.getEFatura(); 
          }

        } else if (this.$route.query.islem == "get") {
          this.loadingdialog = true
          let params = {
            SaticiTip: this.$route.query.st,
            SaticiKod: unescape(this.$route.query.sk.replace('%26','&')),
            FatSeri: this.$route.query.fs,
            FatNo: this.$route.query.fn,
            FatTarih: this.$route.query.ft
          }
          tool.http_post(this, 'GelenFaturaLoad', params).then(

            response => {

              if (response.body.Status == true) {


                this.GelenFatura.Fatura = response.body.data

                this.GelenFatura.EskiFatura.SaticiTip = response.body.data.SaticiTip
                this.GelenFatura.EskiFatura.SaticiKod = response.body.data.SaticiKod
                this.GelenFatura.EskiFatura.FatSeri = response.body.data.FatSeri
                this.GelenFatura.EskiFatura.FatNo = response.body.data.FatNo
                this.GelenFatura.EskiFatura.FatTarih = response.body.data.FatTarih

                this.GelenFatura.KayitTipi = 2
                this.islemtipi = 1
                this.guncellebuton = true
                this.kaydetbuton = false

              } else {
                this.text1 = (response.body.ErrorList || []).join(" ")
                this.snackbar = true
              }
              this.loadingdialog = false

            },

            (response) => {
              this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
              this.loadingdialog = false
              this.snackbar = true
            }

          );


        } else {
          this.snackbar = true
          this.text1 = 'Hatalı url'
        }

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },

      orangoster: function (m) {
        return m * 100;
      }
    },
    methods: {
// PDY: Dosya seçme diyalogu
openPDYFileDialog() {
  if (this.$refs.pdyFile) this.$refs.pdyFile.click();
},

pdyFileSelected(files) {
  const file = files && files[0];
  if (!file) return;

  // 1) Yükleme diyaloğunu aç, beta uyarısını kapat
  this.pdyDoneDialog = false;
  this.pdy.loading = true;
  this.pdy.progress = 10;

  const form = new FormData();
  form.append('file', file);

  this.$http.post(
    auth.API_URL + 'api/coper-azureinvoice/upload',
    form,
    { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }
  ).then((res) => {
    // 2) İstersen gelen sonucu forma uygula
    var body = res && (res.body || res.data) || {};
    if (body && body.data) body = body.data;
    this.applyAzureInvoiceResult(body);

    // 3) Yükleme diyaloğunu kapat, beta uyarısını aç
    this.pdy.progress = 100;
    this.pdy.loading = false;
    this.pdy.done = true;           // başka yerde kullanıyorsan kalsın
    this.pdyDoneDialog = true;      // <<< sadece burada true yap
  }, (response) => {
    // Hata: yükleme diyaloğunu kapat, snackbar göster
    this.pdy.loading = false;
    this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
    this.snackbar = true;
  });
},

applyAzureInvoiceResult(r) {
  const onlyDigits = (s) => (s || '').toString().replace(/\D+/g, '');
  const toIsoOrNull = (s) => s || null;

  let fatPara = r.ParaBirimi || null;
  if (fatPara === 'TRY') fatPara = 'TL';

  if (r.SeriNo) this.GelenFatura.Fatura.FatSeri = (r.SeriNo || '').toString().substr(0, 3);
  if (r.EvrakNo) {
    const num = onlyDigits(r.EvrakNo);
    if (num) this.GelenFatura.Fatura.FatNo = parseInt(num.slice(-10));
    this.GelenFatura.Fatura.EvrakNo = r.EvrakNo;
  }

  if (r.FaturaTarihi) {
    this.GelenFatura.Fatura.FatTarih = toIsoOrNull(r.FaturaTarihi);
    this.GelenFatura.Fatura.VadeTarihi = toIsoOrNull(r.VadeTarihi) || toIsoOrNull(r.FaturaTarihi);
    this.GelenFatura.Fatura.HesaplananVade = toIsoOrNull(r.VadeTarihi) || toIsoOrNull(r.FaturaTarihi);
  }

  if (fatPara) this.GelenFatura.Fatura.FatPara = fatPara;

  if (typeof r.Matrah === 'number') this.GelenFatura.Fatura.ToplamTutar = r.Matrah;
  if (typeof r.ToplamKdv === 'number') this.GelenFatura.Fatura.ToplamKDVTutar = r.ToplamKdv;
  if (typeof r.TevkifatTutar === 'number') this.GelenFatura.Fatura.ToplamTevkifatTutar = r.TevkifatTutar;
  if (typeof r.FaturaTutar === 'number') {
    this.GelenFatura.Fatura.ToplamKDVliTutar = r.FaturaTutar;
    this.GelenFatura.Fatura.FaturaNetTutar =
      r.FaturaTutar - (this.GelenFatura.Fatura.ToplamTevkifatTutar || 0);
  }

  if (r.Aciklama) this.GelenFatura.Fatura.Aciklama = r.Aciklama;
  if (r.Ettn) this.uuid = r.Ettn;
},

onPDYConfirm() {
  this.pdyDoneDialog = false;
  this.text1 = 'OCR bilgileri forma aktarıldı. Lütfen kontrol edip kaydedin.';
  this.snackbar = true;
},

    
     getSaticiTip: function (satisTip) {
      let _resultSaticTipText = null;
      this.itemssaticitip.forEach((element) => {
        if (element.Kod == satisTip) {
          _resultSaticTipText = element.Aciklama;
        }
      });
      return _resultSaticTipText;
      },
      setSaticiTip(val){
        this.GelenFatura.Fatura.SaticiTip = val;
      },


      // PNR numarasindan rezervasyon ekranini acar. Adres bicimi projedeki
      // diger sayfalarla ayni (karlilikraporu, odemeraporu, komisyonfaturasi,
      // transferliste ...).
      //
      // Hedef ise BILEREK farkli. O sayfalar "_target" veriyor; bu standart
      // bir hedef adi olmadigi icin tarayici onu isimli bir pencere sayiyor ve
      // her tiklama ayni sekmeyi yeniden kullaniyor. Burada her PNR kendi
      // sekmesinde acilsin istendi, o yuzden "_blank".
      //
      // Ayri sekme ayrica gerekli: gelen fatura formunda kaydedilmemis
      // degisiklikler olabilir, ayni sekmede gezinmek onlari goturur.
      //
      // DIKKAT: bu dosyadaki git() BASKA bir sey yapiyor -- baska bir gelen
      // faturayi ayni sekmede aciyor. Karistirilmasin diye ayri isim verildi.
      pnrAc(item) {
        if (!item || !item.PNR_No) { return }
        const url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + item.PNR_No
        window.open(url, "_blank")
      },

      /**
       * Kalemdeki saticinin kartini yeni sekmede acar.
       *
       * Adres bicimi uygulamanin geri kalaniyla ayni (coper/acente, charter,
       * feribot, gemi ... index sayfalarindaki goDetail metotlari):
       *   #/coper/saticilar/goster/id?kod=<kod>&tip=<tip>
       *
       * escape() KULLANILIYOR, encodeURIComponent DEGIL: karsi taraf
       * goster.vue:445'te unescape ile okuyor, ikisi esli calismali.
       *
       * "_blank" sart: goster.vue parametreleri beforeMount'ta okuyor. Ayni
       * sekmeye ikinci kez acilirsa SPA yalnizca hash'i degistirir, bilesen
       * yeniden kurulmaz ve ekranda ONCEKI satici kalir.
       */
      saticiAc(item) {
        if (!item || !item.SaticiKod || !item.SaticiTip) { return }
        const url = "#/coper/saticilar/goster/id?kod=" + escape(item.SaticiKod) +
          "&tip=" + item.SaticiTip
        window.open(url, "_blank")
      },

      // Konaklama vergisi satirinda KDV, tevkifat ve stopaj olmaz: isaret
      // konunca hepsi sifirlanir, KDV'li tutar matraha esitlenir. Alanlar
      // ayrica diyalogda pasiflesiyor (yukaridaki :aktif / :disabled
      // baglantilari) -- sadece sifirlamak yetmezdi, cunku tevkifat ve stopaj
      // KDV'den farkli olarak kayitta yeniden hesaplanmiyor, girilen deger
      // oldugu gibi gidiyor.
      //
      // Isaret kaldirilinca eski degerler GERI GELMEZ -- saklanmiyor. Alanlar
      // 0 ile acilir, kullanici yeniden girer. Bilincli: hangi oranin dogru
      // oldugunu tahmin etmektense bos birakmak daha guvenli.
      konaklamaVergileriSifirla(deger) {
        if (!deger) { return }
        this.Kalem.KDVYuzde = 0
        this.Kalem.KDVTutar = 0
        this.Kalem.KDVliTutar = this.truncate2(Number(this.Kalem.Tutar) || 0)
        this.Kalem.TevkifatOran = 0
        this.Kalem.TevkifatTutar = 0
        this.Kalem.StopajOran = 0
        this.Kalem.StopajTutar = 0

        // Aciklama BOS ise kutunun etiketiyle dolduruluyor. Dolu aciklamaya
        // dokunulmuyor: kullanicinin yazdigi metin ezilmemeli. Sadece bosluk
        // iceren metin de bos sayiliyor.
        //
        // Isaret kaldirilinca metin SILINMIYOR -- otomatik yazilanla elle
        // yazilani birbirinden ayirmiyoruz, silmek kullanicinin metnini
        // goturme riski tasir.
        if (!String(this.Kalem.Aciklama || '').trim()) {
          this.Kalem.Aciklama = this.$t('Accommodation-Tax')
        }
      },

      // Satici tipi -> rozet gorunumu. Ikon/renk secimi satir ekleme
      // diyalogundaki PNR listesiyle birebir ayni tutuldu ki ayni satici iki
      // listede de ayni gorunsun. Haritada olmayan tip (eslesmeyen kalemlerde
      // gelen 0, ya da diyalogda da karsiligi bulunmayan 16) null dondurur;
      // cagiran taraf rozeti hic cizmez.
      saticiRozeti(tip) {
        const harita = {
          1:  ['hotel',           'pink',            'Hotel'],
          2:  ['rv_hookup',       'orange',          'Transfer'],
          3:  ['restaurant',      'deep-purple',     'Restaurant'],
          4:  ['local_see',       'yellow accent-4', this.$t('Tour')],
          5:  ['departure_board', 'green',           this.$t('Rent-A-Car')],
          6:  ['emoji_people',    'teal accent-4',   this.$t('Guide')],
          7:  ['museum',          'orange',          this.$t('Museum')],
          8:  ['flight_takeoff',  'blue darken-4',   this.$t('Airline')],
          9:  ['directions_boat', 'cyan darken-2',   this.$t('Cruise')],
          10: ['category',        'pink',            this.$t('Other')],
          11: ['style',           'brown',           this.$t('Visa')],
          12: ['style',           'deep-purple',     this.$t('Tour-Operator')],
          13: ['style',           'info',            'Konsolosluk'],
          14: ['verified_user',   'lime',            this.$t('Insurance')],
          15: ['directions_boat', 'blue',            this.$t('Ferry')]
        }
        const r = harita[tip]
        return r ? { ikon: r[0], renk: r[1], etiket: r[2] } : null
      },
      toplammaliyetBul(secililist) {

        var sonuc = {
          maliyet: 0,
          kdvtutari: 0
        }

        if (secililist.length != 0) {
          secililist.forEach(element => {
            sonuc.maliyet = sonuc.maliyet + element.KalemMaliyet
            sonuc.kdvtutari = sonuc.kdvtutari + element.KDVTutar
          });

        } 
        return sonuc
      },
      stopajtutarblur() {
        if (this.SatirGelenFatura.Tutar != 0) {
          this.SatirGelenFatura.StopajOran = this.SatirGelenFatura.StopajTutar / this.SatirGelenFatura.Tutar * 100
        } else {
          this.SatirGelenFatura.StopajOran = 0
        }
      },
      tutarblur() {
        this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.KDVYuzde
        this.SatirGelenFatura.TevkifatTutar = this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran
        this.SatirGelenFatura.StopajTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.StopajOran

      },

      sontutarkontrol(toplamdeger, toplam, deger) {
        toplam = this.roundNumber(toplam, 2)

        if (toplamdeger < toplam) {
          var fark = toplam - toplamdeger
          var kdvtut = deger + fark
          return kdvtut
        } else if (toplamdeger > toplam) {
          var sonek = this.roundNumber(toplamdeger - deger, 2);
          var eklenecek = toplam - sonek
          var kdvtutar = eklenecek // - fark
          return kdvtutar
        } else {
          return deger
        }
      },
      twodigitcalc(bolunen, bolen) {
        var dizi = []
        var a = parseFloat(bolunen)
        var b = parseFloat(bolen)
        if (bolen != 0 && bolunen != 0) {
          var bolum = this.roundNumber(a / b, 2)
          var top = 0
          var kalani = 0
          for (var x = 0; x < b; x++) {
            kalani = a - top
            if (x + 1 != b) {
              dizi.push(bolum)
            } else {
              dizi.push(this.roundNumber(kalani, 2))
            }
            top = top + bolum
          }
          return dizi;
        } else {
          for (let x = 0; x < bolen; x++) {
            dizi.push(0)
          }
          return dizi;
        }




      },
      git(val) {
        var url = "#/fatura/copergelenfatura/id?islem=get&st=" + val.SaticiTip + '&sk=' + val.SaticiKod + '&fs=' + val
          .FatSeri + '&fn=' + val.FatNo + '&ft=' + val.FatTarih
        window.open(url, "_self");
      },
truncate2(x) {
  return Math.trunc(x * 100) / 100;
},
kalemguncellekaydet() {
   const tutar = Number(this.Kalem.Tutar);
  // Konaklama vergisi satirinda KDV, tevkifat ve stopaj olmaz. Onay kutusu
  // isaretlendiginde alanlar zaten sifirlaniyor, ama kurali kayit aninda da
  // garantiye almak gerekiyor: e-faturadan ZATEN isaretli gelen kalemlerde
  // kutunun degisim olayi hic tetiklenmiyor, dolayisiyla sifirlama calismamis
  // oluyor.
  const konaklama = !!this.Kalem.KonaklamaVergiSatiri;
  const oran = konaklama ? 0 : Number(this.Kalem.KDVYuzde);

  // API ile aynı hesap
  const hamKdv = tutar * oran / 100;
  const kdvTutar = this.truncate2(hamKdv);
  const kdvliTutar = this.truncate2(tutar + kdvTutar);

  this.Kalem.KDVTutar = kdvTutar;
  this.Kalem.KDVliTutar = kdvliTutar;

  var indexno = this.duzenlenenkayitindex;

  var kayit = {
    KDVYuzde: oran,
    Tutar: this.truncate2(tutar),
    KDVTutar: kdvTutar,
    KDVliTutar: kdvliTutar,
    PNR_No: Number(this.Kalem.PNR_No),
    TevkifatOran: konaklama ? 0 : this.Kalem.TevkifatOran,
    TevkifatTutar: konaklama ? 0 : this.truncate2(this.Kalem.TevkifatTutar),
    StopajOran: konaklama ? 0 : this.Kalem.StopajOran,
    StopajTutar: konaklama ? 0 : this.truncate2(this.Kalem.StopajTutar),
    IslemRef: this.Kalem.IslemRef,
    Aciklama: this.Kalem.Aciklama,
    KonaklamaVergiSatiri: this.Kalem.KonaklamaVergiSatiri,
    SaticiTip: this.Kalem.SaticiTip,
    SaticiKod: this.Kalem.SaticiKod
  };

  this.GelenFatura.Fatura.Kalemler.splice(indexno, 1, kayit);

  this.kalemdialog = false;
  this.diptopla();
},
      diptopla() {
        this.GelenFatura.Fatura.ToplamTutar = 0
        this.GelenFatura.Fatura.ToplamKDVliTutar = 0
        this.GelenFatura.Fatura.ToplamKDVTutar = 0
        this.GelenFatura.Fatura.ToplamTevkifatTutar = 0
        this.GelenFatura.Fatura.ToplamStopajTutar = 0
        this.GelenFatura.Fatura.FaturaNetTutar = 0


        this.GelenFatura.Fatura.Kalemler.forEach(element => {
          this.GelenFatura.Fatura.ToplamTutar = this.GelenFatura.Fatura.ToplamTutar + element.Tutar
          this.GelenFatura.Fatura.ToplamKDVliTutar = this.GelenFatura.Fatura.ToplamKDVliTutar + element.KDVliTutar
          this.GelenFatura.Fatura.ToplamKDVTutar = this.GelenFatura.Fatura.ToplamKDVTutar + element.KDVTutar
          this.GelenFatura.Fatura.ToplamTevkifatTutar = this.GelenFatura.Fatura.ToplamTevkifatTutar + element
            .TevkifatTutar
          this.GelenFatura.Fatura.ToplamStopajTutar = this.GelenFatura.Fatura.ToplamStopajTutar + element
            .StopajTutar


        });

        this.GelenFatura.Fatura.FaturaNetTutar = this.GelenFatura.Fatura.ToplamKDVliTutar - this.GelenFatura.Fatura
          .ToplamTevkifatTutar


      },

      kalanVarmi(x, y) {
        var sonuc = {
          durum: false,
          bolum: 0,
          kalan: 0
        }

        var c = this.roundNumber(x / y, 2);
        var carpim = c * y
        var kalan = this.roundNumber(100 - carpim, 2)

        if (kalan != 0) {
          sonuc.durum = true
          sonuc.kalan = kalan
          sonuc.bolum = c
        } else {
          sonuc.durum = false
          sonuc.kalan = 0
          sonuc.bolum = c
        }
        return sonuc
      },

      roundNumber(num, scale) {
        if (!("" + num).includes("e")) {
          return +(Math.round(num + "e+" + scale) + "e-" + scale);
        } else {
          var arr = ("" + num).split("e");
          var sig = ""
          if (+arr[1] + scale > 0) {
            sig = "+";
          }
          return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
        }
      },

      esitOranla() {

        if (this.secilenkayitlar.length > 0) {
          if (this.SatirGelenFatura.Tutar > 0) {

            var secilenkayityedek = this.secilenkayitlar
            this.secilenkayitlar = []
            this.SatirGelenFatura.MatrahToplam = 0
            this.SatirGelenFatura.KDVToplam = 0
            this.SatirGelenFatura.TevkifatToplam = 0
            this.SatirGelenFatura.TutarToplam = 0
            var giris = true
            var bolmesonuc = this.kalanVarmi(100, secilenkayityedek.length)
            var fiyatindex = 0
            var tutarlarim = this.twodigitcalc(this.SatirGelenFatura.Tutar, secilenkayityedek.length)
            var kdvtutarlarim = this.twodigitcalc(this.SatirGelenFatura.KDVTutar, secilenkayityedek.length)
            var tevkifattutarlarim = this.twodigitcalc(this.SatirGelenFatura.TevkifatTutar, secilenkayityedek.length)
            var stopajtutarlarim = this.twodigitcalc(this.SatirGelenFatura.StopajTutar, secilenkayityedek.length)
            secilenkayityedek.forEach(element => {
              if (bolmesonuc.durum == true && giris == true) {
                giris = false
              }
              var indexno = this.itemsgelen.indexOf(element)
              var kayit = {
                PnrNo: element.PnrNo,
                SaticiTip: element.SaticiTip,
                SaticiKod: element.SaticiKod,
                SaticiAd: element.SaticiAd,
                TurOperatoru: element.TurOperatoru,
                Donem1: element.Donem1,
                Donem2: element.Donem2,
                KalemMaliyet: element.KalemMaliyet,
                KDVYuzde: this.SatirGelenFatura.KDVYuzde,
                Tutar: tutarlarim[fiyatindex],
                KDVTutar: kdvtutarlarim[fiyatindex],
                KDVliTutar: tutarlarim[fiyatindex] + kdvtutarlarim[fiyatindex],
                TevkifatTutar: tevkifattutarlarim[fiyatindex],
                TevkifatOran: this.SatirGelenFatura.TevkifatOran,
                StopajTutar: stopajtutarlarim[fiyatindex],
                StopajOran: this.SatirGelenFatura.StopajOran,
                IslemRef: element.IslemRef
              }
              this.SatirGelenFatura.MatrahToplam = this.SatirGelenFatura.MatrahToplam + kayit.Tutar
              this.SatirGelenFatura.KDVToplam = this.SatirGelenFatura.KDVToplam + kayit.KDVTutar
              this.SatirGelenFatura.TevkifatToplam = this.SatirGelenFatura.TevkifatToplam + kayit.TevkifatTutar
              this.SatirGelenFatura.TutarToplam = this.SatirGelenFatura.TutarToplam + kayit.Tutar - kayit
                .TevkifatTutar

              this.itemsgelen.splice(indexno, 1, kayit)
              this.secilenkayitlar.push(kayit)
              fiyatindex++
            });

          } else {
            this.text1 = this.$t('Your-amount-must-be-greater-than-zero');
            this.snackbar = true
          }
        } else {
          this.text1 = this.$t('Please-select-items')
          this.snackbar = true
        }


      },
      maliyetegoreOranla() {
        if (this.secilenkayitlar.length > 0) {
          if (this.SatirGelenFatura.Tutar > 0) {
            this.SatirGelenFatura.MatrahToplam = 0
            this.SatirGelenFatura.KDVToplam = 0
            this.SatirGelenFatura.TevkifatToplam = 0
            var toplammaliyet = 0
            var toplamKdv = 0
            var toplamStopajTutar = 0
            var toplamTevkifatTutar = 0
            this.secilenkayitlar.forEach(element => {
              toplammaliyet = toplammaliyet + (element.KalemMaliyet - element.KDVTutar) 
              toplamKdv = toplamKdv + element.KDVTutar
              toplamStopajTutar = toplamStopajTutar + element.StopajTutar
              toplamTevkifatTutar = toplamTevkifatTutar + element.TevkifatTutar
            });
            var secilenkayityedek = this.secilenkayitlar
            this.secilenkayitlar = []
            this.SatirGelenFatura.MatrahToplam = 0
            this.SatirGelenFatura.KDVToplam = 0
            this.SatirGelenFatura.TevkifatToplam = 0
            this.SatirGelenFatura.TutarToplam = 0
            var x = 0
            var toplamkdv = 0
            var toplamtutar = 0
            var toplamtevkifat = 0
            var toplamstopaj = 0

            secilenkayityedek.forEach(element => {

              var kdvOran = 0
              var tutarOran = 0
              var tevkifatOran = 0
              var stopajOran = 0
              var kalemMaliyetKdvsiz = 0
              var kdvtut = 0
              var tutar = 0
              var tevkifattutar = 0
              var stopajtutar = 0


              if (element.KalemMaliyet != 0) {
                kalemMaliyetKdvsiz = element.KalemMaliyet - element.KDVTutar;

                if (isNaN(element.KDVTutar / toplamKdv)) {
                  kdvtut = 0;  // element.KDVTutar / toplamKdv
                  }else{
                    kdvtut = this.roundNumber(this.SatirGelenFatura.KDVTutar * element.KDVTutar / toplamKdv, 2);  // element.KDVTutar / toplamKdv
                  }

                  if (isNaN(kalemMaliyetKdvsiz / toplammaliyet)) {
                    tutar = 0
                  }else{
                    tutar = this.roundNumber(this.SatirGelenFatura.Tutar * kalemMaliyetKdvsiz / toplammaliyet, 2); // kalemMaliyetKdvsiz / toplammaliyet
                  }

                if (isNaN(element.TevkifatTutar / toplamTevkifatTutar)) {
                  tevkifattutar = 0;
                }else{
                  tevkifattutar = this.roundNumber(this.SatirGelenFatura.TevkifatTutar * element.TevkifatTutar / toplamTevkifatTutar, 2);// bunları hazırla
                }
                if (isNaN(element.StopajTutar / toplamStopajTutar)) {
                  stopajtutar = 0;
                }else{
                  stopajtutar = this.roundNumber(this.SatirGelenFatura.StopajTutar * element.StopajTutar / toplamStopajTutar, 2);  // bunları hazırla
                }
              }

              toplamkdv = toplamkdv + this.roundNumber(kdvtut, 2)
              toplamtutar = toplamtutar + this.roundNumber(tutar, 2)
              toplamtevkifat = toplamtevkifat + this.roundNumber(tevkifattutar, 2)
              toplamstopaj = toplamstopaj + this.roundNumber(stopajtutar, 2)

              if (x == secilenkayityedek.length - 1) {

                  if (isNaN(element.KDVTutar / toplamKdv)) {
                  kdvOran = 0
                  }else{
                    kdvOran = element.KDVTutar / toplamKdv;
                  }

                kdvtut = this.sontutarkontrol(toplamkdv, this.SatirGelenFatura.KDVTutar, this.SatirGelenFatura
                  .KDVTutar * kdvOran)// bu orankları  // element.KDVTutar / toplamKdv ıle tek tek ozel olarak test et 


                  if (isNaN(kalemMaliyetKdvsiz / toplammaliyet)) {
                    tutarOran = 0
                  }else{
                    tutarOran = kalemMaliyetKdvsiz / toplammaliyet;
                  }

                  tutar = this.sontutarkontrol(toplamtutar, this.SatirGelenFatura.Tutar, this.SatirGelenFatura.Tutar * tutarOran)

                
                if (isNaN(element.TevkifatTutar / toplamTevkifatTutar)) {
                  tevkifatOran = 0
                  }else{
                    tevkifatOran = element.TevkifatTutar / toplamTevkifatTutar;
                  }
                  tevkifattutar = this.sontutarkontrol(toplamtevkifat, this.SatirGelenFatura.TevkifatTutar, this
                  .SatirGelenFatura.TevkifatTutar * tevkifatOran)
               

                  if (isNaN(element.StopajTutar / toplamStopajTutar)) {
                    stopajOran = 0
                  }else{
                    stopajOran = element.StopajTutar / toplamStopajTutar;
                  }
                stopajtutar = this.sontutarkontrol(toplamstopaj, this.SatirGelenFatura.StopajTutar, this
                  .SatirGelenFatura.StopajTutar * stopajOran)

              }


              var indexno = this.itemsgelen.indexOf(element)
              var kayit = {
                PnrNo: element.PnrNo,
                SaticiTip: element.SaticiTip,
                SaticiKod: element.SaticiKod,
                SaticiAd: element.SaticiAd,
                TurOperatoru: element.TurOperatoru,
                Donem1: element.Donem1,
                Donem2: element.Donem2,
                KalemMaliyet: element.KalemMaliyet,
                KDVYuzde: this.SatirGelenFatura.KDVYuzde,
                Tutar: this.roundNumber(tutar, 2),
                KDVTutar: this.roundNumber(kdvtut, 2),
                KDVliTutar: this.roundNumber(tutar, 2) + this.roundNumber(kdvtut, 2),
                TevkifatTutar: this.roundNumber(tevkifattutar, 2),
                TevkifatOran: this.SatirGelenFatura.TevkifatOran,
                StopajTutar: this.roundNumber(stopajtutar, 2),
                StopajOran: this.SatirGelenFatura.StopajOran,
                IslemRef: element.IslemRef
              }

              this.SatirGelenFatura.MatrahToplam = this.SatirGelenFatura.MatrahToplam + kayit.Tutar
              this.SatirGelenFatura.KDVToplam = this.SatirGelenFatura.KDVToplam + kayit.KDVTutar
              this.SatirGelenFatura.TevkifatToplam = this.SatirGelenFatura.TevkifatToplam + kayit.TevkifatTutar
              this.SatirGelenFatura.TutarToplam = this.SatirGelenFatura.TutarToplam + kayit.Tutar - kayit
                .TevkifatTutar

              this.secilenkayitlar.push(kayit)

              this.itemsgelen.splice(indexno, 1, kayit)
              x = x + 1
            });

          } else {
            this.text1 = this.$t('Your-amount-must-be-greater-than-zero');
            this.snackbar = true
          }

        } else {
          this.text1 = this.$t('Please-select-items')
          this.snackbar = true
        }





      },
      kalemGetir() {

        this.secilenkayitlar = []
        this.itemsgelen = []
        this.pnrkalemloading = true

        var yeniliste = []

        let params = {
          Tip: 1,
          Id: this.SatirGelenFatura.PnrNo,
          FaturaParaBirimi: this.GelenFatura.Fatura.FatPara,
          KomisyonDus: false

        }


        tool.http_post(this, 'GelenFaturaPNRKalemList', params).then(
          response => {

            if (response.body.Status == true) {

         
              this.SatirGelenFatura.KDVYuzde = this.GelenFatura.Fatura.Satici.KDV



              response.body.data.forEach(element => {
                var kayit = {
                  PnrNo: this.SatirGelenFatura.PnrNo,
                  SaticiTip: element.SaticiTip,
                  SaticiKod: element.Satici.kod,
                  SaticiAd: element.Satici.isim,
                  TurOperatoru: element.TurOperatoru.kod,
                  Donem1: element.Donem1,
                  Donem2: element.Donem2,
                  KalemMaliyet: element.KalemMaliyet,
                  KDVYuzde: element.KdvOrani,
                  Tutar: 0,
                  KDVTutar: element.KdvTutari,
                  KDVliTutar: 0,
                  TevkifatTutar: 0,
                  TevkifatOran: 0,
                  StopajTutar: 0,
                  StopajOran: 0,
                  IslemRef: element.IslemRef,
                  KisiIsim:element.KisiIsim
                }


                yeniliste.push(kayit);
              });

              this.itemsgelen = yeniliste


              if (response.body.data.length > 0) {
                this.kalemkayitvarmi = true
              } else {
                this.kalemkayitvarmi = false
              }

              this.pnrkalemloading = false

              
              if (this.GelenFatura.Fatura.SaticiTip == 12) {
                if (this.pnrtip == false) {
                  this.secilenkayitlar = this.itemsgelen
                  let sonuc = this.toplammaliyetBul(this.secilenkayitlar)
                  this.SatirGelenFatura.Tutar = sonuc.maliyet / ((this.SatirGelenFatura.KDVYuzde / 100) + 1)
                  this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.KDVYuzde
                } else {

                  this.secilenkayitlar = []
                  this.itemsgelen.forEach(element => {
                    if (element.TurOperatoru == this.GelenFatura.Fatura.Satici.kod) {
                      this.secilenkayitlar.push(element)
                    }
                  });
                  let sonuc = this.toplammaliyetBul(this.secilenkayitlar)

                  this.SatirGelenFatura.Tutar = sonuc.maliyet / ((this.SatirGelenFatura.KDVYuzde / 100) + 1)
                  this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura
                    .KDVYuzde
                }

              } else {

                if (this.pnrtip == false) {
                  this.secilenkayitlar = this.itemsgelen
                  let sonuc = this.toplammaliyetBul(this.secilenkayitlar)

                  this.SatirGelenFatura.Tutar = sonuc.maliyet / ((this.SatirGelenFatura.KDVYuzde / 100) + 1)
                  this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura
                    .KDVYuzde

                } else {
                  this.secilenkayitlar = []
                  this.itemsgelen.forEach(element => {
                    if (element.SaticiKod == this.GelenFatura.Fatura.Satici.kod) {
                      this.secilenkayitlar.push(element)
                    }
                  });

                  let sonuc = this.toplammaliyetBul(this.secilenkayitlar)
                 
                  this.SatirGelenFatura.Tutar = sonuc.maliyet / ((this.SatirGelenFatura.KDVYuzde / 100) + 1)
                  this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura
                    .KDVYuzde
                }
              }
            } else {
              this.text1 = (response.body.ErrorList || []).join(" ")
              this.snackbar = true
              this.pnrkalemloading = false
              this.kalemkayitvarmi = false
            }
          },

          (response) => {
            this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
            this.snackbar = true
            this.pnrkalemloading = false
            this.kalemkayitvarmi = false
          }
        );



      },
      getparabirimiDefault(val){
        return helpers.getparabirimiDefault(val)
      },
      getparabirimi() {
        return helpers.getparabirimi()
      },
      faturatoplambul() {
        this.SerbestFatura.Tutarlar.FaturaToplam = 0
        this.satiritems.forEach(element => {
          if (element.KdvTip == 'H') {
            this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.FaturaToplam + element
              .Tutar +
              element
              .KdvTutar - this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv

          } else {
            this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.FaturaToplam + element
              .Tutar -
              this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv
          }
        });
      },
      satirguncellekaydet() {

        const index = this.secilensatirno


        var yedeksatiritems = []

        yedeksatiritems = this.satiritems

        this.satiritems = []

        this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar - this.yedeksatirkayit
          .Tutar
        this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv - this.yedeksatirkayit.Kdv
        this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv - this.yedeksatirkayit
          .Tevkifat
        this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto - this.yedeksatirkayit.iskonto


        var satiryeni = {
          TeslimBilgileri: {
            SokakAdi: this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi,
            BinaAdi: this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi,
            BinaNo: this.SerbestFaturaDetay.TeslimBilgileri.BinaNo,
            TeslimSehir: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir,
            TeslimPostaKodu: this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu,
            TeslimUlke: this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke,
            TeslimSarti: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti,
            GTIPNo: this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo,
            TransferKodu: this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu,
            KabinNo: this.SerbestFaturaDetay.TeslimBilgileri.KabinNo,
            KabinAdedi: this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi,
            KabinCinsi: this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi,
            TeslimOdeme: this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme
          },
          MuhasebeKodu: this.SerbestFaturaDetay.MuhasebeKodu,
          Aciklama: this.SerbestFaturaDetay.Aciklama,
          Referans: {
            Kod: this.SerbestFaturaDetay.Referans.Kod
          },
          Masraf: {
            Code: this.SerbestFaturaDetay.Masraf.Code
          },
          Miktar: this.SerbestFaturaDetay.Miktar,
          LineNote: this.SerbestFaturaDetay.LineNote,
          Birim: this.SerbestFaturaDetay.Birim,
          BirimFiyat: this.SerbestFaturaDetay.BirimFiyat,
          Tutar: this.SerbestFaturaDetay.Tutar,
          TevkifatDetayTutar: this.SerbestFaturaDetay.TevkifatDetayTutar,
          DovizTutar: this.SerbestFaturaDetay.DovizTutar,
          TevkifatDetayOran: this.SerbestFaturaDetay.TevkifatDetayOran,
          IskontoYuzde: this.SerbestFaturaDetay.IskontoYuzde,
          IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
          KdvKodu: this.SerbestFaturaDetay.KdvKodu,
          KdvMuhKodu: this.SerbestFaturaDetay.KdvMuhKodu, //
          IskMuhKodu: this.SerbestFaturaDetay.IskMuhKodu, //
          KdvTutar: this.SerbestFaturaDetay.KdvTutar,
          KdvTip: this.SerbestFaturaDetay.KdvTip,
          KdvYuzde: this.SerbestFaturaDetay.KdvYuzde,
          IstisnaKodu: this.SerbestFaturaDetay.IstisnaKodu,
          TevkifatKodu: this.SerbestFaturaDetay.TevkifatKodu,
          Tip: this.SerbestFaturaDetay.Tip,
          EfaturaDetayBilgileri: {
            SiparisID: null,
            SiparisTarihi: null
          },
          AdresBilgi: {
            Unvani: null,
            Unvani2: null,
            Adres1: null,
            Adres2: null,
            IlceSehir: null,
            Email: null,
            VergiDairesi: null,
            VergiNo: null,
            TcKimlikNo: null,
            Adi: null,
            Soyadi: null,
            TUnvani: null,
            DigerAdi: null,
            OnAdiEki: null
          }
        }




        for (var i = 0; i < yedeksatiritems.length; i++) {


          if (index == i) {
            this.satiritems.push(satiryeni)
          } else {
            this.satiritems.push(yedeksatiritems[i])
          }
        }

        this.satirdialog = false
        this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar + satiryeni.Tutar
        this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv + satiryeni.KdvTutar
        this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv + satiryeni
          .TevkifatDetayTutar
        this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto + satiryeni.IskontoTutar
        this.faturatoplambul();

      },
      faturaiade() {

        var url = '#/fatura/coperiade/id?' + 'ft=' + this.GelenFatura.Fatura.FatTarih + '&sk=' + this.GelenFatura.Fatura
          .Satici.kod + '&st=' + this.GelenFatura.Fatura.SaticiTip + '&fs=' +
          this.GelenFatura.Fatura.FatSeri + '&fn=' + this.GelenFatura.Fatura.FatNo + '&islem=yeni'
        window.open(url, '_target')
      },
      satirsil(a) {

        this.$refs.onaydialog.open(this.$t('Are-you-sure-you-want-to-delete-this-record'), 1).then(
          sonuc => {
            if (sonuc == true) {
              const index = this.GelenFatura.Fatura.Kalemler.indexOf(a)
              if (index != -1) {
                this.GelenFatura.Fatura.Kalemler.splice(index, 1)
               this.diptopla();

              }
            }
          });
      },
      satirduzenle(a) {




        var kayit = {
          KDVYuzde: a.KDVYuzde,
          Tutar: a.Tutar,
          KDVliTutar: a.KDVliTutar,
          KDVTutar: a.KDVTutar,
          PNR_No: a.PNR_No,
          TevkifatOran: a.TevkifatOran,
          TevkifatTutar: a.TevkifatTutar,
          StopajOran: a.StopajOran,
          StopajTutar: a.StopajTutar,
          IslemRef: a.IslemRef,
          Aciklama: a.Aciklama,
          // Kalem duzenleme diyalogundaki onay kutusu bu alani kullaniyor.
          // E-faturadan gelen kalemlerde deger XML'deki 0059 vergi kodundan
          // otomatik geliyor, kutu onu degistirmeye izin veriyor. Bool'a
          // sabitleniyor: alani hic tasimayan eski kalemlerde undefined
          // gelirse kutu belirsiz kalir ve POST govdesinden tumuyle duser.
          KonaklamaVergiSatiri: !!a.KonaklamaVergiSatiri,
          // Sunucuda PersonDetails uzerinden turetilen salt-okunur alanlar.
          // Kayda etkileri yok ama tasinmazlarsa kalem duzenlenir duzenlenmez
          // satici rozeti ekrandan kayboluyor.
          SaticiTip: a.SaticiTip,
          SaticiKod: a.SaticiKod
        }

        this.Kalem = kayit

        this.duzenlenenkayitindex = this.GelenFatura.Fatura.Kalemler.indexOf(a);
        this.kalemdialog = true
      },
      satirekle: satirekle,
      Kaydet: Kaydet,
      KaydetYeni: KaydetYeni,
      KaydetGuncelle: KaydetGuncelle,
      satirkaydet: satirkaydet,
      Tevkifatkdvhesapla: Tevkifatkdvhesapla,
      kurgetir: kurgetir,
      kurgetir2: kurgetir2,
      faturasil: faturasil,
      getEFatura:getEFatura,
    },
    beforeMount: beforeMount,
    components: {
      'parainputevents': parainputevents,
      'dovizinput': dovizinput,
      'yuzdeinput': yuzdeinput,
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      masrafmerkezicomp,
      geneltiplist,
      yetkidialog,
      onaydialog,
      genelarama,
      pnrbul,
      geneltipara,
      muhasebefistipara,
      saticiara,
      snackbarcomp,
      kaydetbutonu

    },
    watch: {

      'secilenkayitlar': function (val) {

        var sonuc = this.toplammaliyetBul(val)

        this.SatirGelenFatura.Tutar = sonuc.maliyet / ((this.SatirGelenFatura.KDVYuzde / 100) + 1)

        this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.KDVYuzde


        this.SatirGelenFatura.TevkifatTutar = this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran

        this.SatirGelenFatura.StopajTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.StopajOran


      },
      'SatirGelenFatura.KDVYuzde': function (val) {
        var sonuc = this.toplammaliyetBul(this.secilenkayitlar)

   
        if(typeof val != "undefined"){
        this.SatirGelenFatura.Tutar = sonuc.maliyet / ((val / 100) + 1)

        this.SatirGelenFatura.KDVTutar = (this.SatirGelenFatura.Tutar / 100) * val

        this.SatirGelenFatura.TevkifatTutar = this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran

        this.SatirGelenFatura.StopajTutar = (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.StopajOran

        }





      },
      'SatirGelenFatura.TevkifatOran': function (val) {
        if (val > 0 && this.SatirGelenFatura.KDVTutar > 0) {
          this.SatirGelenFatura.TevkifatTutar = this.SatirGelenFatura.KDVTutar * val
        } else {
          this.SatirGelenFatura.TevkifatTutar = 0
        }
      },
      'SatirGelenFatura.StopajOran': function (val) {
        if (val > 0 && this.SatirGelenFatura.Tutar > 0) {
          this.SatirGelenFatura.StopajTutar = (this.SatirGelenFatura.Tutar / 100) * val
        } else {
          this.SatirGelenFatura.StopajTutar = 0
        }
      },
      'Kalem.KDVYuzde': function (val) {
        if (val > 0) {
          this.Kalem.KDVTutar = (this.Kalem.Tutar / 100) * val
        }
      },
      'Kalem.TevkifatOran': function (val) {
        if (val > 0 && this.Kalem.KDVTutar > 0) {
          this.Kalem.TevkifatTutar = this.Kalem.KDVTutar * val
        } else {
          this.Kalem.TevkifatTutar = 0
        }
      },
      'Kalem.StopajOran': function (val) {
        if (val > 0 && this.Kalem.Tutar > 0) {
          this.Kalem.StopajTutar = (this.Kalem.Tutar / 100) * val
        } else {
          this.Kalem.StopajTutar = 0
        }
      },
      'SerbestFatura.FaturaTip': function (val) {

        if (val == 1) {


          // 2 = yalnizca "Tamam" cikan bilgilendirme; donusune gore yapilacak bir sey yok.
          this.$refs.onaydialog.open(
            this.$t('Details-regarding-return-invoice-will-entered-after-save-update-process'), 2)
        }
      },



    }
  }


  function getEFatura() {
  setTimeout(() => {
    var prm = {
      UUID: this.uuid,
      PNR_No:this.pnrno

    };
    tool.api_post(this, "EFatura/GetInvoiceHtml", prm).then(
      (response) => {

        if (response.body.Status == true) {

          this.GelenFatura.Fatura.FatSeri = response.body.data.FaturaNo.substring(0, 3);
          this.GelenFatura.Fatura.FatNo = parseInt(response.body.data.FaturaNo.substring(7, 16));
          this.GelenFatura.Fatura.FatTarih = response.body.data.FaturaTarihi;
          this.GelenFatura.Fatura.VadeTarihi = response.body.data.FaturaTarihi;
          this.GelenFatura.Fatura.HesaplananVade = response.body.data.FaturaTarihi;
          
          this.GelenFatura.Fatura.Aciklama = this.uuid;

          this.GelenFatura.Fatura.FatPara = response.body.data.ParaBirimi;

          if(response.body.data.Invoice.paymentExchangeRateField != null)
          {
            this.GelenFatura.Fatura.FatKur = response.body.data.Invoice.paymentExchangeRateField.calculationRateField.valueField;
          }

          if(this.GelenFatura.Fatura.FatPara=="TRY")
          {
            this.GelenFatura.Fatura.FatPara="TL";
          }
          

        

          this.GelenFatura.Fatura.SaticiTip=response.body.data.CoperDefGelenFatura.SaticiTip;
          this.GelenFatura.Fatura.SaticiKod=response.body.data.CoperDefGelenFatura.SaticiKod;


          // Saticinin TAM kaydi API'den geliyor:
          // GetInvoiceHtml -> CoperDefGelenFatura.Satici (data.SaticiKodAra).
          // SaticiTable'in JSON sekli saticiara'nin bekledigi sekille birebir
          // ayni oldugu icin (id, kod, isim, tip, CariKod, KDV,
          // YurtIci_YurtDisi) esleme yapilmiyor, dogrudan ataniyor.
          //
          // Onceden istemci bunun icin SaticiAraV2'ye AYRI bir istek
          // atiyordu; arama artik sunucuda. Alan gelmezse (guncellenmemis
          // API) mevcut nesne korunur, sayfa patlamaz.
          if (response.body.data.CoperDefGelenFatura.Satici) {
            this.GelenFatura.Fatura.Satici = response.body.data.CoperDefGelenFatura.Satici
          }

          
          this.GelenFatura.Fatura.Kalemler=response.body.data.CoperDefGelenFatura.Kalemler;

          this.diptopla();


        } else {
          this.text1 = (response.body.ErrorList || []).join(" ");
          this.snackbar = true
        }
      },
      (response) => {
        this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
          this.snackbar = true
      }
    );
  }, 500);
}


  function kurgetir() {
    // Bos doviz kodunda kur sorulmaz; sunucu "Doviz Kodu Bos olamaz" diye 500 donuyordu.
    var dovizKod = this.GelenFatura.Fatura.SatisPara
    if (dovizKod == null || dovizKod == '') {
      return
    }

    var params1 = {
      Tarih: this.GelenFatura.Fatura.FatTarih,
      DovizKod: this.GelenFatura.Fatura.SatisPara
    }


    this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
      headers: auth.getAuthCompaniesInfo()
    }).then((response) => {
        if(response.body == 0.0){
          this.GelenFatura.Fatura.SatisKur = 1
          }else{
          this.GelenFatura.Fatura.SatisKur = response.body
          }
      
    }, (response) => {
      this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
      this.snackbar = true
    })

  }

  function kurgetir2() {
    // Bos doviz kodunda kur sorulmaz; sunucu "Doviz Kodu Bos olamaz" diye 500 donuyordu.
    var dovizKod = this.GelenFatura.Fatura.FatPara
    if (dovizKod == null || dovizKod == '') {
      return
    }

    var params1 = {
      Tarih: this.GelenFatura.Fatura.FatTarih,
      DovizKod: this.GelenFatura.Fatura.FatPara
    }

    this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
      headers: auth.getAuthCompaniesInfo()
    }).then((response) => {
          if(response.body == 0.0){
          this.GelenFatura.Fatura.FatKur = 1
          }else{
          this.GelenFatura.Fatura.FatKur = response.body
          }
    }, (response) => {
      this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
      this.snackbar = true
    })

  }





  function Tevkifatkdvhesapla() {
    var params1 = {
      TevkifatOran: this.SerbestFaturaDetay.TevkifatDetayOran,
      KdvTutar: this.SerbestFaturaDetay.KdvTutar
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetWithHoldingAmount', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.TevkifatDetayTutar = response.body.TevkifatTutar
    }, (response) => {
      this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
      this.snackbar = true
    })
  }

  function satirekle() {
    
    if (this.GelenFatura.Fatura.Satici.kod != null & this.GelenFatura.Fatura.Satici.kod != '') {


      if (this.GelenFatura.Fatura.Satici.CariKod == null || this.GelenFatura.Fatura.Satici.CariKod == "") {
        this.text1 = this.$t('seller-you-selected-does-not-have-any-current-codes')
        this.snackbar = true
      }

      this.satirdialog = true
      this.secilenkayitlar = []
      this.pnretiket = this.GelenFatura.Fatura.Satici.kod + this.$t('Select-pnr-belonging-seller')
      this.itemsgelen = []
      this.SatirGelenFatura.PnrNo = null
      this.SatirGelenFatura.Aciklama = null
      this.SatirGelenFatura.KDVYuzde = 0
      this.SatirGelenFatura.Tutar = 0
      this.SatirGelenFatura.KDVTutar = 0
      this.SatirGelenFatura.KDVliTutar = 0
      this.SatirGelenFatura.TevkifatTutar = 0
      this.SatirGelenFatura.TevkifatOran = 0
      this.SatirGelenFatura.StopajTutar = 0
      this.SatirGelenFatura.StopajOran = 0
      this.SatirGelenFatura.MatrahToplam = 0
      this.SatirGelenFatura.TutarToplam = 0
      this.SatirGelenFatura.KDVToplam = 0
      this.SatirGelenFatura.TevkifatToplam = 0
    } else {
      this.text1 = this.$t('Enter-Seller-Code')
      this.snackbar = true
    }
  }

  function satirkaydet() {
    var durum = false
    this.secilenkayitlar.forEach(element => {

      if (element.KalemMaliyet == 0) {
        durum = true
      }

    });

    if (durum == false) {
      this.maliyetegoreOranla();
    } else {
      this.esitOranla();
    }

    this.secilenkayitlar.forEach(element => {

      var kayit = {
        KDVYuzde: element.KDVYuzde,
        Tutar: element.Tutar,
        KDVliTutar: this.roundNumber(element.KDVliTutar, 2),
        KDVTutar: this.roundNumber(element.KDVTutar, 2),
        PNR_No: Number(element.PnrNo),
        TevkifatOran: element.TevkifatOran,
        TevkifatTutar: this.roundNumber(element.TevkifatTutar, 2),
        StopajOran: element.StopajOran,
        StopajTutar: this.roundNumber(element.StopajTutar, 2),
        IslemRef: element.IslemRef,
        // Aciklama diyalog duzeyinde tek alan; bu partide olusturulan
        // butun kalemlere ayni metin yaziliyor.
        Aciklama: this.SatirGelenFatura.Aciklama,
        // PNR listesindeki satici bilgisi. Sunucu bunu zaten PersonDetails
        // uzerinden yeniden turetiyor; burada tasinmasinin sebebi rozetin
        // kaydi beklemeden, satir eklenir eklenmez gorunmesi.
        SaticiTip: element.SaticiTip,
        SaticiKod: element.SaticiKod,
        SaticiAd: element.SaticiAd
      }

      this.GelenFatura.Fatura.Kalemler.push(kayit);
    });

    this.satirdialog = false
    this.diptopla();
  }




  // kaydetbutonu :action'i PARAMETRESIZ bir fonksiyon bekliyor; Kaydet ise
  // kayit/guncelleme ayrimini tip ile yapiyor. Bu iki ince sarmalayici
  // Kaydet'in Promise'ini aynen geciriyor.
  function KaydetYeni() {
    return this.Kaydet('1')
  }

  function KaydetGuncelle() {
    return this.Kaydet('2')
  }

  //kaydetme işlemi
  function Kaydet(tip) {


    if (this.$refs.formgelenfatura.validate()) {



      if (this.GelenFatura.Fatura.Satici.kod != null) {


        if (this.GelenFatura.Fatura.Kalemler.length > 0) {

          this.loadingdialog = true
          this.GelenFatura.KayitTipi = tip
          this.GelenFatura.Fatura.ETTN = this.uuid;
          
          this.GelenFatura.Fatura.SaticiKod = this.GelenFatura.Fatura.Satici.kod
          let params = this.GelenFatura
          // Promise DONDURULUR: kaydetbutonu cevabi bekleyip butonu pasif
          // tutmak icin buna ihtiyac duyar.
          return tool.http_post(this, 'GelenFaturaKaydet', params).then(
            response => {
              this.loadingdialog = false

              if (response.body.Status == true) {
                this.text1 = 'Kayıt işlemi tamamlandı'
                this.snackbar = true


                this.git(response.body.data)
                this.GelenFatura.Fatura = response.body.data

                if (tip == '1') {

                  this.GelenFatura.EskiFatura.SaticiTip = response.body.data.SaticiTip
                  this.GelenFatura.EskiFatura.SaticiKod = response.body.data.SaticiKod
                  this.GelenFatura.EskiFatura.FatSeri = response.body.data.FatSeri
                  this.GelenFatura.EskiFatura.FatNo = response.body.data.FatNo
                  this.GelenFatura.EskiFatura.FatTarih = this.GelenFatura.Fatura.FatTarih
                }




                this.GelenFatura.KayitTipi = 2
                this.islemtipi = 1
                this.guncellebuton = true
                this.kaydetbuton = false


              } else {
                this.text1 = (response.body.ErrorList || []).join(" ")
                this.snackbar = true

              }
            },


            (response) => {
              this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
              this.snackbar = true
              this.loadingdialog = false
            }
          );

        } else {
          this.text1 = this.$t('Please-add-items')
          this.snackbar = true

        }

      } else {
        this.text1 = this.$t('Please-select-seller')
        this.snackbar = true

      }
    } else {

      this.text1 = this.$t('Please-fill-required-fields');
      this.snackbar = true

    }

  }




  function faturasil() {

    // Promise DONDURULUR: kaydetbutonu cevabi bekleyip butonu pasif tutmak icin
    // buna ihtiyac duyar. Zincir onay dialogundan basladigi icin buton dialog
    // aciktan da pasif kalir -- ust uste iki onay penceresi acilamaz.
    return this.$refs.onaydialog.open('Bu faturayı silmek istediğinize emin misiniz?', 1).then(
      sonuc => {
        if (sonuc !== true) {
          return   // kullanici vazgecti; istek atilmaz
        }

        let params = {
          SaticiTip: this.GelenFatura.Fatura.SaticiTip,
          SaticiKod: this.GelenFatura.Fatura.SaticiKod,
          FatSeri: this.GelenFatura.Fatura.FatSeri,
          FatNo: this.$route.query.fn,
          FatTarih: this.GelenFatura.Fatura.FatTarih
        }

        // Bu Promise de DONDURULUR; aksi halde zincir onay verilir verilmez
        // bitmis sayilir ve buton silme istegi ucarken tekrar aktif olur.
        return tool.http_post(this, 'GelenFaturaSil', params).then(

          response => {

            if (response.body.Status == true) {

              this.text1 = 'Faturanız silindi.'
              this.snackbar = true

              var url = '#/coper/page/formlar/gelenfaturalistesi'
              setTimeout(function () {
                window.open(url, '_self')
              }.bind(this), 6000)

            } else {

              this.text1 = (response.body.ErrorList || []).join(" ")
              this.snackbar = true

            }

          },

          (response) => {

            this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
            this.snackbar = true

          }

        );
      });


  }








  function beforeMount() {


  }





</script>

<style scoped>
  /* Kalem kartindaki tutar/KDV sutunu.

     Kart, v-layout'un flex ogesi. Flex ogelerinin varsayilan min-width'i
     "auto" ve bu, ogeyi ICERIGININ altina kuculmekten alikoyuyor - uzun
     bir deger karti sisirip flex'in disina tasiriyor. min-width:0 ile
     kart kuculebiliyor ve Vuetify'nin .v-list__tile__sub-title kurali
     (nowrap + overflow:hidden + text-overflow:ellipsis) is goruyor.

     Kural ACIKLAMA yuzunden eklendi; aciklama sonra iki sutunu birden
     kaplayan ayri bir satira alindi ama kural kaldi - uzun bir tutar da
     ayni sekilde tasirdi.

     DOGRULAMA: basitlestirilmis bir kopyada tasma URETILEMEDI, o yuzden
     bir sure dogrulanmamis sayildi. Sonra degisiklik geri alininca
     tasmanin GERI DONDUGU gercek ekranda gozlendi - sebep budur.

     NOT: sayfada bes yerde style="'overflow=inherit';" var; ayni sorunu
     cozmek icin yazilmis ama GECERSIZ CSS (tirnak icinde, ":" yerine
     "="). Bilerek dokunulmadi - asil sebep overflow degil min-width. */
  .kalem-degerleri {
    min-width: 0;
  }

  /* Aciklama satiri: tutar ve etiket sutunlarinin ALTINDA, ikisinin
     genisligi kadar. Kirpma burada elle veriliyor cunku artik
     v-list-tile-sub-title degil duz bir div - Vuetify'nin kirpma kurali
     ona uygulanmiyor. Tam metin title ile ustune gelince gorunuyor. */
  .kalem-aciklama {
    width: 100%;
    padding: 0 16px;
    color: rgba(0, 0, 0, 0.54);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Cari rozeti iki satirli: ustte hesap kodu, altta unvan. Tek satirda uzun
     unvan rozeti kabin disina tasiriyordu (500px genislikte olculdu: +311px).

     >>> sart: stil scoped, .v-chip__content ise VChip'in kendi sablonunda
     uretiliyor, scoped niteligi ona islenmiyor. Ayni desen projede
     bilet/yeni.vue ve coper/raporlar/transferoperasyon.vue'de de var. */
  .cari-rozet {
    height: auto;
    /* max-width olmadan yetmiyor: .v-chip inline-flex, icerige gore buyuyup
       kabi asmaya devam ediyor (olculdu). */
    max-width: 100%;
  }

  /* Vuetify .v-chip__content'e height: 32px veriyor (_chips.styl); iki satirin
     sigmasi icin serbest birakiliyor. min-height, unvan gelmedigi durumda
     rozetin mevcut 32px gorunumunu aynen koruyor. */
  .cari-rozet >>> .v-chip__content {
    height: auto;
    min-height: 32px;
  }

  .cari-rozet-metin {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    /* min-width: 0 olmadan flex ogesi icerigin altina inemiyor (varsayilan
       min-width: auto) ve uzun unvan yine tasiyor. */
    min-width: 0;
  }

  /* Etiket ve kod ortadan bolunmesin ("Cari Hesap / Kodu:" gibi). */
  .cari-rozet-kod {
    white-space: nowrap;
  }

  /* Dikey dolgu KOSULLU: rozetin yuksekligini 32px'te tutan sey avatar
     (height: 32px !important), metin degil -- unvan yokken .v-chip__content'e
     dolgu vermek rozeti 32'den 40'a cikariyordu (olculdu). Bu yuzden nefes
     payi yalnizca ikinci satir gercekten varken veriliyor.
     v-if kapaliyken Vue yorum dugumu birakir, yorum eleman sayilmaz;
     :only-child bu yuzden dogru calisir. */
  .cari-rozet-kod:not(:only-child) {
    padding-top: 4px;
  }

  /* Vuetify'in nowrap'i yalnizca unvanda geri aliniyor; bosluksuz cok uzun
     bir unvan da bolunebilsin. */
  .cari-rozet-unvan {
    white-space: normal;
    word-break: break-word;
    line-height: 1.3;
    padding-bottom: 4px;
  }

  .pnr-link {
    cursor: pointer;
    text-decoration: underline;
    color: #1976d2;
  }

  .outer {

    position: relative;
    display: inline-block;
    margin: 0 10px;
    padding-top: inherit+100px;

  }

  .inner {
    position: absolute;
    top: 104%;
    left: 50%;
    padding-block-start: 30px;
    padding-block-end: 10px;
  }

  .icorta {
    margin: 0px auto;
    height: 226px;
    color: #fff;
    position: absolute;
    left: 92%;
    top: 95%;
    margin-left: -110px;
    margin-top: -15px;
  }

  .rotate {
    -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    transform: translateX(-50%) translateY(-50%) rotate(-90deg);

  }
</style>